(function () {
    'use strict';

    var fallbackTestIds = {
        statistics: {
            course_table: 'statistics-course-table',
            course_column_learning_unit: 'statistics-course-column-learning-unit',
            course_progress: 'statistics-course-progress',
            course_action_complete: 'statistics-course-action-complete',
            course_action_reset_progress: 'statistics-course-action-reset-progress',
            course_reset_progress_modal: 'statistics-course-reset-progress-modal',
            course_reset_progress_confirm_button: 'statistics-course-reset-progress-confirm-button',
            course_export_button: 'statistics-course-export-button',
            course_export_csv_action: 'statistics-course-export-csv-action',
            course_learning_unit_select: 'statistics-course-learning-unit-select',
            course_learning_unit_native_select: 'statistics-course-learning-unit-native-select',
            course_client_select: 'statistics-course-client-select',
            course_client_native_select: 'statistics-course-client-native-select',
            course_group_select: 'statistics-course-group-select',
            course_group_native_select: 'statistics-course-group-native-select',
            course_include_subgroups_checkbox: 'statistics-course-include-subgroups-checkbox',
            course_include_historical_progress_checkbox: 'statistics-course-include-historical-progress-checkbox',
            course_send_message_button: 'statistics-course-send-message-button',
            course_message_modal: 'statistics-course-message-modal',
            course_message_subject_input: 'statistics-course-message-subject-input',
            course_message_body_input: 'statistics-course-message-body-input',
            message_create_body_editor: 'message-create-body-editor',
            course_message_email_checkbox: 'statistics-course-message-email-checkbox',
            course_message_submit_button: 'statistics-course-message-submit-button',
            test_filter_button: 'statistics-test-filter-button',
            test_status_select: 'statistics-test-status-select',
            test_table: 'statistics-test-table',
            test_column_learning_unit: 'statistics-test-column-learning-unit',
            test_column_status: 'statistics-test-column-status',
            test_column_first_name: 'statistics-test-column-first-name',
            test_column_last_name: 'statistics-test-column-last-name'
        }
    };

    function getE2eConfig() {
        if (!window.global_vars || !window.global_vars.e2e) {
            return null;
        }

        return window.global_vars.e2e;
    }

    function getFallbackTestIds(group) {
        return fallbackTestIds[group] || null;
    }

    function retryUntil(callback, options) {
        var attempts = 0;
        var maxAttempts = options.maxAttempts || 20;
        var interval = options.interval || 250;

        var timer = window.setInterval(function () {
            attempts++;

            if (callback() || attempts >= maxAttempts) {
                window.clearInterval(timer);
            }
        }, interval);
    }

    function isGroupsPage(e2e) {
        var configuredGroupsPage = e2e && e2e.pages ? e2e.pages.groups : null;

        return (typeof page !== 'undefined' && page === configuredGroupsPage)
            || !!document.querySelector('[data-testid="backend-groups-page"]');
    }

    function isTopicsPage(e2e) {
        var configuredTopicsPage = e2e && e2e.pages ? e2e.pages.topics : null;

        return (typeof page !== 'undefined' && page === configuredTopicsPage)
            || !!document.querySelector('[data-testid="backend-topics-tree"]');
    }

    function getGroupTreeItemLabel(item, treeInstance) {
        var nodeId = item.getAttribute('data-nodeid');
        var node = nodeId !== null && treeInstance && typeof treeInstance.getNode === 'function'
            ? treeInstance.getNode(Number(nodeId))
            : null;

        if (!node || typeof node.text !== 'string') {
            return '';
        }

        var textContainer = document.createElement('div');
        textContainer.innerHTML = node.text;

        var label = textContainer.textContent.trim();

        if (node.link_for !== null && typeof node.link_for !== 'undefined') {
            label = label.replace(/^\[\s*/, '').replace(/\s*\]$/, '').trim();
        }

        return label;
    }

    function applyGroupTreeItemTestIds() {
        var e2e = getE2eConfig();
        var groupTestIds = e2e && e2e.test_ids ? e2e.test_ids.groups : null;
        var treeItemTestId = groupTestIds ? groupTestIds.tree_item : null;
        var rootTreeItemTestId = groupTestIds ? groupTestIds.root_tree_item : null;
        var treeItemToggleTestId = groupTestIds && groupTestIds.tree_item_toggle
            ? groupTestIds.tree_item_toggle
            : 'backend-groups-tree-item-toggle';

        if (!treeItemTestId || !rootTreeItemTestId || !isGroupsPage(e2e) || typeof $ === 'undefined') {
            return false;
        }

        var $tree = $('#tree');

        if (typeof $tree.treeview !== 'function') {
            return false;
        }

        var treeInstance = $tree.treeview(true);
        var $items = $tree.find('.list-group-item');

        if (!$items.length || !treeInstance || typeof treeInstance.getNode !== 'function') {
            return false;
        }

        var allItemsReady = true;

        $items.each(function () {
            var nodeId = this.getAttribute('data-nodeid');
            var node = nodeId !== null ? treeInstance.getNode(Number(nodeId)) : null;
            var label = getGroupTreeItemLabel(this, treeInstance);
            var isRoot = node
                && node.parent_id !== null
                && typeof node.parent_id !== 'undefined'
                && String(node.parent_id) === '0';
            var testId = isRoot
                ? rootTreeItemTestId
                : treeItemTestId;

            this.setAttribute('data-testid', testId);

            var toggle = this.querySelector('.expand-icon');

            if (toggle) {
                setDataTestId(toggle, treeItemToggleTestId);
            }

            if (label) {
                this.setAttribute('aria-label', label);
            } else {
                this.removeAttribute('aria-label');
                allItemsReady = false;
            }
        });

        return allItemsReady;
    }

    function observeGroupTreeItems() {
        var e2e = getE2eConfig();
        var refreshHandle = null;
        var hasRenderedItems = false;

        if (!e2e || !isGroupsPage(e2e)) {
            return;
        }

        var tree = document.getElementById('tree');

        if (!tree) {
            return;
        }

        function setTreeReadyWhenAnnotated() {
            refreshHandle = null;

            var hasItems = !!tree.querySelector('.list-group-item');
            var itemsReady = applyGroupTreeItemTestIds();

            if (hasItems) {
                hasRenderedItems = true;
            }

            tree.setAttribute(
                'aria-busy',
                tree.classList.contains('remove-events-tree')
                    || (!itemsReady && !(hasRenderedItems && !hasItems))
                    ? 'true'
                    : 'false'
            );
        }

        function scheduleTreeMetadataRefresh() {
            tree.setAttribute('aria-busy', 'true');

            if (refreshHandle !== null) {
                window.cancelAnimationFrame(refreshHandle);
            }

            refreshHandle = window.requestAnimationFrame(setTreeReadyWhenAnnotated);
        }

        scheduleTreeMetadataRefresh();

        retryUntil(function () {
            if (tree.getAttribute('aria-busy') === 'false') {
                return true;
            }

            scheduleTreeMetadataRefresh();

            return false;
        }, {
            maxAttempts: 20,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        var itemObserver = new MutationObserver(function () {
            scheduleTreeMetadataRefresh();
        });

        itemObserver.observe(tree, {
            childList: true,
            subtree: true
        });

        var busyObserver = new MutationObserver(function () {
            scheduleTreeMetadataRefresh();
        });

        busyObserver.observe(tree, {
            attributes: true,
            attributeFilter: ['class']
        });
    }

    function applyTopicTreeItemTestIds() {
        var e2e = getE2eConfig();
        var topicTestIds = e2e && e2e.test_ids ? e2e.test_ids.topics : null;
        var treeItemTestId = topicTestIds && topicTestIds.tree_item
            ? topicTestIds.tree_item
            : 'backend-topics-tree-item';

        if (!e2e || !treeItemTestId || !isTopicsPage(e2e) || typeof $ === 'undefined') {
            return false;
        }

        var $tree = $('#tree');

        if (typeof $tree.treeview !== 'function') {
            return false;
        }

        var treeInstance = $tree.treeview(true);
        var $items = $tree.find('.list-group-item');

        if (!$items.length || !treeInstance || typeof treeInstance.getNode !== 'function') {
            return false;
        }

        var allItemsReady = true;

        $items.each(function () {
            var nodeId = this.getAttribute('data-nodeid');
            var node = nodeId !== null ? treeInstance.getNode(Number(nodeId)) : null;
            var topicId = node && node.id ? node.id : null;

            this.setAttribute('data-testid', treeItemTestId);

            if (topicId) {
                this.setAttribute('data-topic-id', String(topicId));
            } else {
                this.removeAttribute('data-topic-id');
                allItemsReady = false;
            }
        });

        return allItemsReady;
    }

    function observeTopicTreeItems() {
        var e2e = getE2eConfig();
        var refreshHandle = null;
        var hasRenderedItems = false;

        if (!e2e || !isTopicsPage(e2e)) {
            return;
        }

        var tree = document.getElementById('tree');

        if (!tree) {
            return;
        }

        function setTreeReadyWhenAnnotated() {
            refreshHandle = null;

            var hasItems = !!tree.querySelector('.list-group-item');
            var itemsReady = applyTopicTreeItemTestIds();

            if (hasItems) {
                hasRenderedItems = true;
            }

            tree.setAttribute(
                'aria-busy',
                tree.classList.contains('remove-events-tree')
                    || (!itemsReady && !(hasRenderedItems && !hasItems))
                    ? 'true'
                    : 'false'
            );
        }

        function scheduleTreeMetadataRefresh() {
            tree.setAttribute('aria-busy', 'true');

            if (refreshHandle !== null) {
                window.cancelAnimationFrame(refreshHandle);
            }

            refreshHandle = window.requestAnimationFrame(setTreeReadyWhenAnnotated);
        }

        scheduleTreeMetadataRefresh();

        retryUntil(function () {
            if (tree.getAttribute('aria-busy') === 'false') {
                return true;
            }

            scheduleTreeMetadataRefresh();

            return false;
        }, {
            maxAttempts: 20,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        var itemObserver = new MutationObserver(function () {
            scheduleTreeMetadataRefresh();
        });

        itemObserver.observe(tree, {
            childList: true,
            subtree: true
        });

        var busyObserver = new MutationObserver(function () {
            scheduleTreeMetadataRefresh();
        });

        busyObserver.observe(tree, {
            attributes: true,
            attributeFilter: ['class']
        });
    }

    function applyPageMenuTreeTestIds() {
        var testIds = getTestIds('pages');
        var path = window.location.pathname.replace(/\/+$/, '');
        var tree = document.getElementById('tree');
        var treeInstance;
        var items;
        var allItemsReady = true;

        if (!testIds
            || !testIds.menu_tree_node
            || (path !== '/admin/page' && path !== '/admin/pages')
            || !tree
            || typeof $ === 'undefined'
        ) {
            return false;
        }

        if (typeof $(tree).treeview !== 'function') {
            return false;
        }

        treeInstance = $(tree).treeview(true);
        items = tree.querySelectorAll('.list-group-item[data-nodeid]');

        if (!treeInstance || typeof treeInstance.getNode !== 'function' || !items.length) {
            return false;
        }

        for (var i = 0; i < items.length; i++) {
            var node = treeInstance.getNode(Number(items[i].getAttribute('data-nodeid')));

            setDataTestId(items[i], testIds.menu_tree_node);

            if (node && node.id) {
                setDataAttribute(items[i], 'data-menu-id', node.id);
            } else {
                allItemsReady = false;
            }

            if (node && node.content) {
                setDataAttribute(items[i], 'data-page-menu-kind', 'content');
            } else if (node && node.header) {
                setDataAttribute(items[i], 'data-page-menu-kind', 'header');
            } else {
                items[i].removeAttribute('data-page-menu-kind');
            }
        }

        return allItemsReady;
    }

    function observePageMenuTreeItems() {
        var path = window.location.pathname.replace(/\/+$/, '');
        var tree = document.getElementById('tree');

        if (!getE2eConfig() || (path !== '/admin/page' && path !== '/admin/pages') || !tree) {
            return;
        }

        applyPageMenuTreeTestIds();
        retryUntil(applyPageMenuTreeTestIds, {
            maxAttempts: 20,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            applyPageMenuTreeTestIds();
        }).observe(tree, {
            childList: true,
            subtree: true
        });
    }

    function getFrontendMenuItemSlug(link) {
        var notification = link.querySelector('.notification[id]');
        var source = notification ? notification.getAttribute('id') : '';

        if (!source) {
            source = link.textContent || '';
        }

        return source
            .replace(/_menu$/, '')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    function annotateFrontendMenuItems() {
        var links = document.querySelectorAll('#frontend-menu-overlay #menu-items a.clickable');

        for (var i = 0; i < links.length; i++) {
            var item = links[i].closest('li');
            var onclick = item ? item.getAttribute('onclick') : null;

            if (onclick && /^setItem\(\s*[1-9]\d*\s*\)/.test(onclick.trim())) {
                continue;
            }

            var slug = getFrontendMenuItemSlug(links[i]);

            if (slug) {
                links[i].setAttribute('data-testid', 'app-menu-item-' + slug);
            }
        }
    }

    function getCurrentDescriptionTestId(testIds) {
        var pathname = window.location.pathname;
        var targets = [
            {
                pattern: /\/locations?\/create\/?$/,
                testId: testIds.location_description
            },
            {
                pattern: /\/meetings?\/create(\/[^/]+)?\/?$/,
                testId: testIds.meeting_description
            },
            {
                pattern: /\/rooms?\/create\/?$/,
                testId: testIds.room_description
            },
            {
                pattern: /\/seminars?\/create\/?$|\/seminars?\/[^/]+\/edit\/?$/,
                testId: testIds.seminar_description
            }
        ];

        for (var i = 0; i < targets.length; i++) {
            if (targets[i].testId && targets[i].pattern.test(pathname)) {
                return targets[i].testId;
            }
        }

        return null;
    }

    function setCkEditorDescriptionTestId() {
        var e2e = getE2eConfig();
        var richTextTestIds = e2e && e2e.test_ids ? e2e.test_ids.rich_text : null;
        var descriptionTestId = richTextTestIds ? getCurrentDescriptionTestId(richTextTestIds) : null;

        if (!descriptionTestId) {
            return;
        }

        retryUntil(function () {
            var descriptionElement = document.querySelector('#description');
            var descriptionEditor = descriptionElement && descriptionElement.parentElement
                ? descriptionElement.parentElement.querySelector('.ck-content')
                : null;

            if (!descriptionEditor) {
                return false;
            }

            descriptionEditor.setAttribute('data-testid', descriptionTestId);

            return true;
        }, {
            maxAttempts: 30,
            interval: 250
        });
    }

    function getCurrentUploadTestId(testIds) {
        var pathname = window.location.pathname;
        var targets = [
            {
                pattern: /\/content\/media\/[^/]+\/upload\/?$/,
                marker: 'content_media_id',
                testId: testIds.media_upload
            },
            {
                pattern: /\/pdf-document\/[^/]+\/upload\/?$/,
                marker: 'pdfdocument_id',
                testId: testIds.pdf_document_upload
            },
            {
                pattern: /\/scorm\/upload\/[^/]+\/?$/,
                marker: 'course_id',
                testId: testIds.course_scorm_upload
            }
        ];

        for (var i = 0; i < targets.length; i++) {
            if (targets[i].testId && targets[i].pattern.test(pathname) && document.getElementById(targets[i].marker)) {
                return targets[i].testId;
            }
        }

        return null;
    }

    function setUploadInputTestId() {
        var e2e = getE2eConfig();
        var uploadTestIds = e2e && e2e.test_ids ? e2e.test_ids.uploads : null;
        var uploadTestId = uploadTestIds ? getCurrentUploadTestId(uploadTestIds) : null;

        if (!uploadTestId) {
            return;
        }

        retryUntil(function () {
            var uploadInputs = document.querySelectorAll('#uploadContainer input[type="file"]');

            if (!uploadInputs.length) {
                return false;
            }

            for (var i = 0; i < uploadInputs.length; i++) {
                uploadInputs[i].setAttribute('data-testid', uploadTestId);
            }

            return true;
        }, {
            maxAttempts: 30,
            interval: 250
        });
    }

    function applyApprovalStepTestIds() {
        var e2e = getE2eConfig();
        var approvalTestIds = e2e && e2e.test_ids ? e2e.test_ids.approval : null;
        var settingsPanel = document.querySelector('[data-testid="backend-learning-unit-settings-panel"]');
        var permissionCheckbox = settingsPanel
            ? settingsPanel.querySelector('input[name="permission"]')
            : null;
        var rows = settingsPanel
            ? settingsPanel.querySelectorAll('.supervisor-steps-setting')
            : [];

        if (!approvalTestIds || !permissionCheckbox || !rows.length) {
            return false;
        }

        var isCourseApproval = permissionCheckbox.getAttribute('data-testid') === 'backend-course-setting-approval-required-checkbox';
        var currentTestIds = isCourseApproval ? approvalTestIds.course : approvalTestIds.learning_unit;

        if (!currentTestIds) {
            return false;
        }

        for (var i = 0; i < rows.length; i++) {
            var select = rows[i].querySelector('select[name="steps[]"]');
            var addButton = rows[i].querySelector('button.positive');

            rows[i].removeAttribute('data-testid');

            if (select) {
                select.setAttribute('data-testid', i === 0 ? currentTestIds.first_step : currentTestIds.step);
                select.setAttribute('data-approval-step-index', String(i + 1));
            }

            if (addButton) {
                addButton.removeAttribute('data-testid');
            }
        }

        rows[0].setAttribute('data-testid', currentTestIds.fields);

        var firstAddButton = rows[0].querySelector('button.positive');
        if (firstAddButton) {
            firstAddButton.setAttribute('data-testid', currentTestIds.add_step);
        }

        return true;
    }

    function observeApprovalSteps() {
        var settingsPanel = document.querySelector('[data-testid="backend-learning-unit-settings-panel"]');

        if (!settingsPanel) {
            return;
        }

        applyApprovalStepTestIds();

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        var observer = new MutationObserver(function () {
            applyApprovalStepTestIds();
        });

        observer.observe(settingsPanel, {
            childList: true,
            subtree: true
        });
    }

    function applyQuestionAnswerTestIds() {
        var e2e = getE2eConfig();
        var testIds = e2e && e2e.test_ids ? e2e.test_ids.questions : null;
        var formQuestion = document.getElementById('formQuestion');

        if (!testIds || !formQuestion) {
            return false;
        }

        var rows = formQuestion.querySelectorAll('.answerswrap');
        var container = rows.length && rows[0].closest('fieldset')
            ? rows[0].closest('fieldset')
            : formQuestion;

        container.setAttribute('data-testid', testIds.answers_container);

        for (var i = 0; i < rows.length; i++) {
            rows[i].setAttribute('data-testid', testIds.answer_row);
        }

        var answerInputs = formQuestion.querySelectorAll('input[name="answer[]"]');
        for (var j = 0; j < answerInputs.length; j++) {
            answerInputs[j].setAttribute('data-testid', testIds.answer_input);
        }

        var addButtons = formQuestion.querySelectorAll('.addAnswer');
        for (var k = 0; k < addButtons.length; k++) {
            addButtons[k].setAttribute('data-testid', testIds.add_answer);
        }

        var correctControls = formQuestion.querySelectorAll('input[name="correct"], input[name="correct[]"]');
        for (var l = 0; l < correctControls.length; l++) {
            correctControls[l].setAttribute('data-testid', testIds.correct_answer);
        }

        return rows.length > 0;
    }

    function observeQuestionAnswers() {
        var formObserver = null;
        var observedForm = null;

        if (!getE2eConfig()) {
            return;
        }

        function observeCurrentQuestionForm() {
            var formQuestion = document.getElementById('formQuestion');

            if (!formQuestion) {
                return false;
            }

            applyQuestionAnswerTestIds();

            if (typeof MutationObserver === 'undefined') {
                return true;
            }

            if (formQuestion === observedForm) {
                return true;
            }

            if (formObserver) {
                formObserver.disconnect();
            }

            observedForm = formQuestion;
            formObserver = new MutationObserver(function () {
                applyQuestionAnswerTestIds();
            });

            formObserver.observe(formQuestion, {
                childList: true,
                subtree: true
            });

            return true;
        }

        observeCurrentQuestionForm();

        retryUntil(observeCurrentQuestionForm, {
            maxAttempts: 30,
            interval: 250
        });

        var pageRoot = document.body || document.documentElement;

        if (!pageRoot || typeof MutationObserver === 'undefined') {
            return;
        }

        var pageObserver = new MutationObserver(function () {
            observeCurrentQuestionForm();
        });

        pageObserver.observe(pageRoot, {
            childList: true,
            subtree: true
        });
    }

    function applyUserRestoreActionTestIds() {
        var e2e = getE2eConfig();
        var userTestIds = e2e && e2e.test_ids ? e2e.test_ids.users : null;
        var container = document.getElementById('users-table-container');

        if (!userTestIds || !userTestIds.restore_action || !container) {
            return false;
        }

        var restoreActions = container.querySelectorAll('.restoreUser');

        for (var i = 0; i < restoreActions.length; i++) {
            restoreActions[i].setAttribute('data-testid', userTestIds.restore_action);
        }

        return restoreActions.length > 0;
    }

    function observeUserRestoreActions() {
        var container = document.getElementById('users-table-container');

        if (!container) {
            return;
        }

        applyUserRestoreActionTestIds();

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        var observer = new MutationObserver(function () {
            applyUserRestoreActionTestIds();
        });

        observer.observe(container, {
            childList: true,
            subtree: true
        });
    }

    function applyCurriculumUnitStartActionTestIds(container) {
        var e2e = getE2eConfig();
        var curriculumTestIds = e2e && e2e.test_ids ? e2e.test_ids.curriculum : null;
        var roots = container.querySelectorAll('[data-testid="learner-curriculum-unit"]');

        if (!curriculumTestIds || !curriculumTestIds.unit_start_action || !roots.length) {
            return false;
        }

        for (var i = 0; i < roots.length; i++) {
            var primaryAction = roots[i].querySelector('.learning-unit-buttons .tiles-button, .learning-unit-buttons .btn');

            if (primaryAction) {
                primaryAction.setAttribute('data-testid', curriculumTestIds.unit_start_action);
            }
        }

        return true;
    }

    function observeCurriculumUnitStartActions() {
        var containers = document.querySelectorAll('.serie_items');

        for (var i = 0; i < containers.length; i++) {
            applyCurriculumUnitStartActionTestIds(containers[i]);

            if (typeof MutationObserver === 'undefined') {
                continue;
            }

            var observer = new MutationObserver(function (mutations) {
                for (var j = 0; j < mutations.length; j++) {
                    applyCurriculumUnitStartActionTestIds(mutations[j].target.closest('.serie_items') || mutations[j].target);
                }
            });

            observer.observe(containers[i], {
                childList: true,
                subtree: true
            });
        }
    }

    function observePdfOverlayReadiness() {
        var overlay = document.querySelector('[data-testid="learner-pdf-overlay"]');
        var readinessTimer = null;
        var wasVisible;

        if (!overlay || typeof MutationObserver === 'undefined') {
            return;
        }

        function isVisible() {
            var styles = window.getComputedStyle(overlay);

            return styles.display !== 'none' && styles.visibility !== 'hidden';
        }

        function stopReadinessCheck() {
            if (readinessTimer !== null) {
                window.clearInterval(readinessTimer);
                readinessTimer = null;
            }
        }

        function isReaderReady() {
            try {
                var holder = document.getElementById('iframe_holder_pdf');
                var readerFrame = holder && holder.contentWindow
                    ? holder.contentWindow.document.querySelector('iframe')
                    : null;
                var reader = readerFrame && readerFrame.contentWindow
                    ? readerFrame.contentWindow.PDFViewerApplication
                    : null;
                var totalPages = reader && reader.pdfDocument
                    ? Number(reader.pagesCount)
                    : 0;
                var pdfData = holder && holder.contentWindow
                    ? holder.contentWindow.SharedPdfData
                    : null;

                return totalPages > 0
                    && pdfData
                    && Number(pdfData.totalPages) === totalPages
                    && Array.isArray(pdfData.visitedPages);
            } catch (error) {
                return false;
            }
        }

        function startReadinessCheck() {
            var attempts = 0;
            var maxAttempts = 300;

            stopReadinessCheck();
            overlay.setAttribute('aria-busy', 'true');

            readinessTimer = window.setInterval(function () {
                attempts++;

                if (isReaderReady()) {
                    overlay.setAttribute('aria-busy', 'false');
                    stopReadinessCheck();
                } else if (attempts >= maxAttempts) {
                    stopReadinessCheck();
                }
            }, 100);
        }

        function handleVisibilityChange() {
            var visible = isVisible();

            if (visible && !wasVisible) {
                startReadinessCheck();
            } else if (!visible && wasVisible) {
                stopReadinessCheck();
                overlay.setAttribute('aria-busy', 'true');
            }

            wasVisible = visible;
        }

        wasVisible = isVisible();
        if (wasVisible) {
            startReadinessCheck();
        }

        var observer = new MutationObserver(handleVisibilityChange);

        observer.observe(overlay, {
            attributes: true,
            attributeFilter: ['class', 'hidden', 'style']
        });
    }

    function getTestIds(group) {
        var e2e = getE2eConfig();

        return e2e && e2e.test_ids && e2e.test_ids[group]
            ? e2e.test_ids[group]
            : getFallbackTestIds(group);
    }

    function getAdminUserDetailTestIds() {
        var e2e = getE2eConfig();
        var testIds = getTestIds('admin_user_detail') || {};

        if (!e2e) {
            return null;
        }

        return {
            existing_account_select: testIds.existing_account_select || 'backend-users-detail-existing-account-select',
            existing_account_search: testIds.existing_account_search || 'backend-users-detail-existing-account-search',
            existing_account_option: testIds.existing_account_option || 'backend-users-detail-existing-account-option',
            toast: testIds.toast || 'backend-toast'
        };
    }

    function getSystemConfigurationDeregistrationReasonTestIds() {
        var e2e = getE2eConfig();
        var testIds = getTestIds('super_admin_system_configuration') || {};

        if (!e2e) {
            return null;
        }

        return {
            section: testIds.deregistration_reasons_section || 'super-admin-system-configuration-deregistration-reasons-section',
            name_input: testIds.deregistration_reason_name_input || 'super-admin-system-configuration-deregistration-reason-name-input',
            active_checkbox: testIds.deregistration_reason_active_checkbox || 'super-admin-system-configuration-deregistration-reason-active-checkbox'
        };
    }

    function getSystemConfigurationPrioritizationTestIds() {
        var e2e = getE2eConfig();
        var testIds = getTestIds('super_admin_system_configuration') || {};

        if (!e2e) {
            return null;
        }

        return {
            prioritization_points_values_select: testIds.prioritization_points_values_select || 'super-admin-system-configuration-prioritization-points-values-select',
            prioritization_create_period_confirm_button: testIds.prioritization_create_period_confirm_button || 'super-admin-system-configuration-prioritization-create-period-confirm-button',
            prioritization_close_period_confirm_button: testIds.prioritization_close_period_confirm_button || 'super-admin-system-configuration-prioritization-close-period-confirm-button'
        };
    }

    function getLearnerSeminarInterestTestIds() {
        var e2e = getE2eConfig();
        var testIds = getTestIds('learner_seminar_interest') || {};

        if (!e2e) {
            return null;
        }

        return {
            modal: testIds.modal || 'learner-seminar-interest-modal',
            points_select: testIds.points_select || 'learner-seminar-interest-points-select',
            extra_points_checkbox: testIds.extra_points_checkbox || 'learner-seminar-interest-extra-points-checkbox',
            extra_points_field: testIds.extra_points_field || 'learner-seminar-interest-extra-points-field',
            extra_points_value: testIds.extra_points_value || 'learner-seminar-interest-extra-points-value',
            confirm_button: testIds.confirm_button || 'learner-seminar-interest-confirm-button',
            cancel_button: testIds.cancel_button || 'learner-seminar-interest-cancel-button'
        };
    }

    function getLearnerSeminarSelfBookingTestIds() {
        var e2e = getE2eConfig();
        var testIds = getTestIds('learner_seminar_self_booking') || {};

        if (!e2e) {
            return null;
        }

        return {
            modal: testIds.modal || 'learner-seminar-self-booking-modal',
            for_self_option: testIds.for_self_option || 'learner-seminar-self-booking-for-self-option',
            address_select: testIds.address_select || 'learner-seminar-self-booking-address-select',
            add_address_action: testIds.add_address_action || 'learner-seminar-self-booking-add-address-action',
            confirmation_checkbox: testIds.confirmation_checkbox || 'learner-seminar-self-booking-confirmation-checkbox',
            terms_checkbox: testIds.terms_checkbox || 'learner-seminar-self-booking-terms-checkbox',
            comment_input: testIds.comment_input || 'learner-seminar-self-booking-comment-input',
            next_action: testIds.next_action || 'learner-seminar-self-booking-next-action',
            submit_action: testIds.submit_action || 'learner-seminar-self-booking-submit-action',
            cancel_action: testIds.cancel_action || 'learner-seminar-self-booking-cancel-action'
        };
    }

    function isSeminarUnitType(value) {
        var unitTypes = window.global_vars ? window.global_vars.unit_types : null;
        var seminarType = unitTypes && unitTypes.seminar ? unitTypes.seminar : 'seminar';

        return String(value || '').toLowerCase() === String(seminarType).toLowerCase();
    }

    function setDataTestId(element, testId) {
        if (element && testId) {
            element.setAttribute('data-testid', testId);
        }
    }

    function setDataAttribute(element, name, value) {
        if (!element || value === null || typeof value === 'undefined' || value === '') {
            return;
        }

        element.setAttribute(name, String(value));
    }

    function getText(element) {
        return element && element.textContent
            ? element.textContent.replace(/\s+/g, ' ').trim()
            : '';
    }

    function normalizeSelectorText(text) {
        return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
    }

    function textMatchesAny(text, candidates) {
        var normalizedText = normalizeSelectorText(text);

        for (var i = 0; i < candidates.length; i++) {
            var candidate = normalizeSelectorText(candidates[i]);

            if (candidate && normalizedText.indexOf(candidate) !== -1) {
                return true;
            }
        }

        return false;
    }

    function getTranslationText(key) {
        return window.trans && window.trans.lms && window.trans.lms[key]
            ? String(window.trans.lms[key]).replace(/&[^;]+;/g, '').replace(/\s+/g, ' ').trim()
            : '';
    }

    function getMessageSubjectCandidates(keys, fallbacks) {
        var candidates = fallbacks || [];

        for (var i = 0; i < keys.length; i++) {
            var translated = getTranslationText(keys[i]);

            if (translated) {
                candidates.push(translated);
            }
        }

        return candidates;
    }

    function getDateAttributeValue(value) {
        if (!value) {
            return '';
        }

        if (typeof value === 'string') {
            return value;
        }

        if (value instanceof Date && !isNaN(value.getTime())) {
            return value.toISOString();
        }

        return '';
    }

    function getSafeAttributeSelectorValue(value) {
        return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    }

    function annotateLearnerDashboardCalendarEvents() {
        var testIds = getTestIds('learner_dashboard');
        var calendarRoot = document.getElementById('user_dashboard_calendar');
        var calendar = window.calendarInstances && window.calendarInstances.user_dashboard_calendar
            ? window.calendarInstances.user_dashboard_calendar
            : null;

        if (!testIds || !calendarRoot || document.getElementById('seminars')) {
            return false;
        }

        setDataTestId(calendarRoot, testIds.calendar);

        if (!calendar || typeof calendar.getEvents !== 'function') {
            return false;
        }

        var events = calendar.getEvents();
        var annotated = false;

        for (var i = 0; i < events.length; i++) {
            var event = events[i];
            var props = event.extendedProps || {};

            if (props.unit_type !== 'seminar' || !props.meeting_id) {
                continue;
            }

            var meetingId = String(props.meeting_id);
            var eventElements = calendarRoot.querySelectorAll(
                '[data-meeting_id="' + getSafeAttributeSelectorValue(meetingId) + '"], '
                + '[data-meeting-id="' + getSafeAttributeSelectorValue(meetingId) + '"]'
            );

            for (var j = 0; j < eventElements.length; j++) {
                setDataTestId(eventElements[j], testIds.calendar_event);
                setDataAttribute(eventElements[j], 'data-seminar-id', props.unit_id);
                setDataAttribute(eventElements[j], 'data-meeting-id', meetingId);
                setDataAttribute(eventElements[j], 'data-meeting-name', event.title);
                setDataAttribute(eventElements[j], 'data-meeting-start', event.startStr || getDateAttributeValue(event.start));
                setDataAttribute(eventElements[j], 'data-meeting-end', event.endStr || getDateAttributeValue(event.end));
                annotated = true;
            }
        }

        return annotated || events.length === 0;
    }

    function observeLearnerDashboardCalendar() {
        var calendarRoot = document.getElementById('user_dashboard_calendar');

        if (!getE2eConfig() || !calendarRoot || document.getElementById('seminars')) {
            return;
        }

        retryUntil(annotateLearnerDashboardCalendarEvents, {
            maxAttempts: 40,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        var observer = new MutationObserver(function () {
            annotateLearnerDashboardCalendarEvents();
        });

        observer.observe(calendarRoot, {
            childList: true,
            subtree: true
        });
    }

    function annotateInstructorDashboardCalendarEvents() {
        var testIds = getTestIds('instructor_dashboard');
        var calendarRoot = document.getElementById('user_dashboard_calendar');
        var calendar = window.calendarInstances && window.calendarInstances.user_dashboard_calendar
            ? window.calendarInstances.user_dashboard_calendar
            : null;

        if (!testIds || !calendarRoot || !document.getElementById('seminars')) {
            return false;
        }

        setDataTestId(calendarRoot, testIds.calendar);

        if (!calendar || typeof calendar.getEvents !== 'function') {
            return false;
        }

        var events = calendar.getEvents();
        var annotated = false;

        for (var i = 0; i < events.length; i++) {
            var event = events[i];
            var props = event.extendedProps || {};

            if (props.unit_type !== 'seminar' || !props.meeting_id) {
                continue;
            }

            var meetingId = String(props.meeting_id);
            var eventElements = calendarRoot.querySelectorAll(
                '[data-meeting_id="' + getSafeAttributeSelectorValue(meetingId) + '"], '
                + '[data-meeting-id="' + getSafeAttributeSelectorValue(meetingId) + '"]'
            );

            for (var j = 0; j < eventElements.length; j++) {
                setDataTestId(eventElements[j], testIds.calendar_event);
                annotated = true;
            }
        }

        return annotated || events.length === 0;
    }

    function observeInstructorDashboardCalendar() {
        var calendarRoot = document.getElementById('user_dashboard_calendar');

        if (!getE2eConfig() || !calendarRoot || !document.getElementById('seminars')) {
            return;
        }

        retryUntil(annotateInstructorDashboardCalendarEvents, {
            maxAttempts: 40,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        var observer = new MutationObserver(function () {
            annotateInstructorDashboardCalendarEvents();
        });

        observer.observe(calendarRoot, {
            childList: true,
            subtree: true
        });
    }

    function annotateSeminarMeetingDocuments() {
        var testIds = getTestIds('seminar_meeting_documents');
        var modals = document.querySelectorAll('[data-testid="seminar-meeting-documents-modal"]');
        var preventPreview = window.global_vars
            && window.global_vars.env
            ? window.global_vars.env.PREVENT_PREVIEW
            : false;
        var previewDisabled = preventPreview === true || preventPreview === 'true';
        var annotated = false;

        if (!testIds || !modals.length) {
            return false;
        }

        var taggedUploadInputs = document.querySelectorAll(
            'input[data-testid="' + getSafeAttributeSelectorValue(testIds.upload_input) + '"]'
        );

        for (var i = 0; i < taggedUploadInputs.length; i++) {
            taggedUploadInputs[i].removeAttribute('data-testid');
        }

        for (var j = 0; j < modals.length; j++) {
            var uploadForms = modals[j].querySelectorAll('form.courseDropzone');

            for (var k = 0; k < uploadForms.length; k++) {
                var dropzone = uploadForms[k].dropzone;
                var uploadInput = dropzone ? dropzone.hiddenFileInput : null;

                if (uploadInput) {
                    setDataTestId(uploadInput, testIds.upload_input);
                    annotated = true;
                }
            }

            var files = modals[j].querySelectorAll('li.item-li, tr.file-tr');

            for (var l = 0; l < files.length; l++) {
                var file = files[l];
                var actions = file.querySelectorAll('a');
                var previewIcon = file.querySelector('a .fa-eye');
                var downloadIcon = file.querySelector('a .fa-download');
                var openAction = !previewDisabled && previewIcon ? previewIcon.closest('a') : null;

                if (!openAction) {
                    openAction = file.querySelector('a.image-icon-container:not([href])');
                }

                var downloadAction = !openAction && downloadIcon ? downloadIcon.closest('a') : null;

                setDataTestId(file, testIds.file);

                for (var m = 0; m < actions.length; m++) {
                    if (actions[m].getAttribute('data-testid') === testIds.file_open_action
                        || actions[m].getAttribute('data-testid') === testIds.file_download_action) {
                        actions[m].removeAttribute('data-testid');
                    }
                }

                setDataTestId(openAction, testIds.file_open_action);
                setDataTestId(downloadAction, testIds.file_download_action);
                annotated = true;
            }
        }

        return annotated;
    }

    function observeSeminarMeetingDocuments() {
        var roots = document.querySelectorAll('[id^="meetings-container_"]');

        if (!getE2eConfig() || !roots.length) {
            return;
        }

        annotateSeminarMeetingDocuments();

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        for (var i = 0; i < roots.length; i++) {
            var documentsObserver = new MutationObserver(function () {
                annotateSeminarMeetingDocuments();
            });

            documentsObserver.observe(roots[i], {
                childList: true,
                subtree: true
            });
        }

        var pageObserver = new MutationObserver(function () {
            annotateSeminarMeetingDocuments();
        });

        pageObserver.observe(document.body, {
            childList: true
        });
    }

    function findParagraphByTranslation(container, keys) {
        if (!container) {
            return null;
        }

        var paragraphs = getDirectParagraphs(container);

        for (var i = 0; i < paragraphs.length; i++) {
            var label = paragraphs[i].querySelector('.bold');
            var labelText = getText(label);

            for (var j = 0; j < keys.length; j++) {
                var translated = getTranslationText(keys[j]);

                if (translated && labelText.indexOf(translated) !== -1) {
                    return paragraphs[i];
                }
            }
        }

        return null;
    }

    function findDescriptionParagraph(container) {
        if (!container) {
            return null;
        }

        var paragraphs = getDirectParagraphs(container);

        for (var i = 0; i < paragraphs.length; i++) {
            var firstElement = paragraphs[i].firstElementChild;

            if (!firstElement || !firstElement.classList || !firstElement.classList.contains('bold')) {
                return paragraphs[i];
            }
        }

        return null;
    }

    function getDirectParagraphs(container) {
        var paragraphs = [];

        if (!container) {
            return paragraphs;
        }

        for (var i = 0; i < container.children.length; i++) {
            if (container.children[i].tagName === 'P') {
                paragraphs.push(container.children[i]);
            }
        }

        return paragraphs;
    }

    function annotateLearnerSeminarMeetingDetailModal() {
        var testIds = getTestIds('learner_seminar_meeting_detail');
        var modals = document.querySelectorAll('dialog[id^="meeting_modal_"]');

        if (!testIds || !modals.length) {
            return false;
        }

        for (var i = 0; i < modals.length; i++) {
            var modal = modals[i];
            var topFields = modal.querySelectorAll('.unit-details-top-row .info-field');
            var info = modal.querySelector('.meeting-modal-info');

            setDataTestId(modal, testIds.modal);
            setDataTestId(modal.querySelector('.meetings-modal-close'), testIds.close);
            setDataTestId(modal.querySelector('h3[id^="meeting_modal_"]'), testIds.title);

            if (topFields.length > 0) {
                setDataTestId(topFields[0].querySelector('.ml-10') || topFields[0], testIds.start_date);
            }

            if (topFields.length > 1) {
                setDataTestId(topFields[1].querySelector('span') || topFields[1], testIds.start_time);
            }

            if (topFields.length > 2) {
                setDataTestId(topFields[2].querySelector('span') || topFields[2], testIds.end_date);
            }

            if (topFields.length > 3) {
                setDataTestId(topFields[3].querySelector('span') || topFields[3], testIds.end_time);
            }

            setDataTestId(findParagraphByTranslation(info, ['FreeCapacity']), testIds.free_capacity);
            setDataTestId(findParagraphByTranslation(info, ['SeminarInstructor']), testIds.instructor);
            setDataTestId(findParagraphByTranslation(info, ['MeetingLocation', 'Location']), testIds.location);
            setDataTestId(findParagraphByTranslation(info, ['Address']), testIds.address);
            setDataTestId(findParagraphByTranslation(info, ['Room']), testIds.room);
            setDataTestId(findDescriptionParagraph(info), testIds.description);
        }

        return true;
    }

    function observeLearnerSeminarMeetingDetailModal() {
        var pageRoot = document.querySelector('[id^="meetings-container_"]');

        if (!getE2eConfig() || !pageRoot) {
            return;
        }

        annotateLearnerSeminarMeetingDetailModal();

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        var observer = new MutationObserver(function () {
            annotateLearnerSeminarMeetingDetailModal();
        });

        observer.observe(pageRoot, {
            childList: true,
            subtree: true
        });
    }

    function annotateLearnerSeminarAppointmentRegisterButtons() {
        var appointmentTestIds = getTestIds('learner_seminar_appointment') || {};
        var registerButtonTestId = appointmentTestIds.register_button
            || 'learner-seminar-appointment-register-button';
        var appointments;
        var annotated = false;

        if (!getE2eConfig() || !registerButtonTestId) {
            return false;
        }

        appointments = document.querySelectorAll('[data-testid="learner-seminar-appointment"]');

        for (var i = 0; i < appointments.length; i++) {
            var buttons = appointments[i].querySelectorAll('button[onclick^="enroll("]:not([disabled])');

            for (var j = 0; j < buttons.length; j++) {
                setDataTestId(buttons[j], registerButtonTestId);
                annotated = true;
            }
        }

        return annotated;
    }

    function observeLearnerSeminarAppointmentRegisterButtons() {
        var root;
        var observer;

        if (!getE2eConfig()) {
            return;
        }

        annotateLearnerSeminarAppointmentRegisterButtons();
        annotateLearnerSeminarAppointmentActions();

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        root = document.querySelector('[id^="meetings-container_"]');

        if (!root) {
            return;
        }

        observer = new MutationObserver(function () {
            annotateLearnerSeminarAppointmentRegisterButtons();
            annotateLearnerSeminarAppointmentActions();
        });

        observer.observe(root, {
            childList: true,
            subtree: true
        });
    }

    function annotateAdminConfigurationDashboard() {
        var testIds = getTestIds('admin_configuration');

        if (!testIds) {
            return;
        }

        setDataTestId(document.querySelector('a[href="#dashboard"][data-toggle="tab"]'), testIds.dashboard_tab);
        setDataTestId(document.getElementById('user_calendar'), testIds.dashboard_user_calendar_checkbox);
        setDataTestId(document.getElementById('seminar_sessions'), testIds.dashboard_seminar_sessions_checkbox);
        setDataTestId(document.getElementById('save_dashboard_settings'), testIds.save_button);
    }

    function annotateSystemConfigurationDeregistrationReasons() {
        var testIds = getSystemConfigurationDeregistrationReasonTestIds();
        var table = document.getElementById('deregistration_reasons-table');
        var nameInputs;
        var activeCheckboxes;
        var i;

        if (!testIds || !table) {
            return false;
        }

        setDataTestId(table, testIds.section);

        nameInputs = table.querySelectorAll(
            'input[type="text"][id^="reason_"], input[type="text"][data-setting^="reason_"]'
        );
        activeCheckboxes = table.querySelectorAll('input[type="checkbox"][data-setting^="reasonEnabled_"]');

        for (i = 0; i < nameInputs.length; i++) {
            setDataTestId(nameInputs[i], testIds.name_input);
        }

        for (i = 0; i < activeCheckboxes.length; i++) {
            setDataTestId(activeCheckboxes[i], testIds.active_checkbox);
        }

        return nameInputs.length > 0 || activeCheckboxes.length > 0;
    }

    function observeSystemConfigurationDeregistrationReasons() {
        var table;
        var tableBody;
        var observer;

        if (!getE2eConfig()) {
            return;
        }

        table = document.getElementById('deregistration_reasons-table');

        if (!table) {
            return;
        }

        annotateSystemConfigurationDeregistrationReasons();

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        tableBody = table.querySelector('tbody') || table;
        observer = new MutationObserver(function () {
            annotateSystemConfigurationDeregistrationReasons();
        });

        observer.observe(tableBody, {
            childList: true,
            subtree: true
        });
    }

    function getBootstrapSelect(select) {
        if (!select) {
            return null;
        }

        if (select.parentElement && select.parentElement.classList.contains('bootstrap-select')) {
            return select.parentElement;
        }

        var sibling = select.nextElementSibling;

        if (sibling && sibling.classList.contains('bootstrap-select')) {
            return sibling;
        }

        return select.parentElement
            ? select.parentElement.querySelector('.bootstrap-select')
            : null;
    }

    function annotateBootstrapSelect(selectSelector, config) {
        var selects = document.querySelectorAll(selectSelector);
        var found = false;

        for (var i = 0; i < selects.length; i++) {
            var select = selects[i];
            var picker = getBootstrapSelect(select);
            var button = picker ? picker.querySelector('button.dropdown-toggle') : null;
            var search = picker ? picker.querySelector('.bs-searchbox input') : null;
            var optionSelector = config.optionSelector
                || '.dropdown-menu li[data-original-index] a';
            var options = picker ? picker.querySelectorAll(optionSelector) : [];

            if (button) {
                if (config.nativeSelect) {
                    setDataTestId(select, config.select);
                    if (button.getAttribute('data-testid') === config.select) {
                        button.removeAttribute('data-testid');
                    }
                } else {
                    if (select.getAttribute('data-testid') === config.select) {
                        select.removeAttribute('data-testid');
                    }

                    setDataTestId(button, config.select);
                }

                found = true;
            } else if (config.fallbackToSelect !== false) {
                setDataTestId(select, config.select);
            }

            if (config.search) {
                setDataTestId(search, config.search);
            }

            if (config.option) {
                for (var j = 0; j < options.length; j++) {
                    var optionIndex = options[j].parentElement
                        ? Number(options[j].parentElement.getAttribute('data-original-index'))
                        : NaN;
                    var sourceOption = !isNaN(optionIndex) ? select.options[optionIndex] : null;
                    var optionName = sourceOption ? getText(sourceOption) : getText(options[j]);

                    setDataTestId(options[j], config.option);

                    if (config.nameAttribute) {
                        setDataAttribute(options[j], config.nameAttribute, optionName);
                    }

                    if (config.sourceAttributes && sourceOption) {
                        for (var k = 0; k < config.sourceAttributes.length; k++) {
                            var attributeName = config.sourceAttributes[k];

                            setDataAttribute(options[j], attributeName, sourceOption.getAttribute(attributeName));
                        }
                    }
                }
            }
        }

        return found || selects.length > 0;
    }

    function getLearningUnitTopicPickerTestIds() {
        var e2e = getE2eConfig();
        var testIds = getTestIds('learning_unit') || {};

        if (!e2e) {
            return null;
        }

        return {
            topic_native_select: testIds.topic_native_select || 'backend-learning-unit-topic-native-select',
            topic_select: testIds.topic_select || 'backend-learning-unit-topic-select',
            topic_option: testIds.topic_option || 'backend-learning-unit-topic-option'
        };
    }

    function isBackendTestSettingsPage() {
        var path = window.location.pathname.replace(/\/+$/, '');

        return path === '/admin/test/create' || /^\/admin\/test\/\d+\/edit$/.test(path);
    }

    function annotateBackendTestPassPercentageInput() {
        var testIds = getTestIds('learning_unit');
        var settingsPanel = document.querySelector('[data-testid="backend-learning-unit-settings-panel"]');

        if (!testIds || !testIds.pass_percentage_input || !isBackendTestSettingsPage() || !settingsPanel) {
            return false;
        }

        setDataTestId(
            settingsPanel.querySelector('input[name="need_to_pass"]'),
            testIds.pass_percentage_input
        );

        return true;
    }

    function observeBackendTestPassPercentageInput() {
        var settingsPanel;

        if (!getE2eConfig() || !isBackendTestSettingsPage()) {
            return;
        }

        settingsPanel = document.querySelector('[data-testid="backend-learning-unit-settings-panel"]');

        if (!settingsPanel) {
            return;
        }

        annotateBackendTestPassPercentageInput();

        retryUntil(annotateBackendTestPassPercentageInput, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            annotateBackendTestPassPercentageInput();
        }).observe(settingsPanel, {
            childList: true,
            subtree: true
        });
    }

    function annotateLearningUnitTopicPicker() {
        var testIds = getLearningUnitTopicPickerTestIds();

        if (!testIds) {
            return false;
        }

        setDataTestId(document.querySelector('#topic_id.selectpicker'), testIds.topic_native_select);

        return annotateBootstrapSelect('#topic_id.selectpicker', {
            select: testIds.topic_select,
            option: testIds.topic_option,
            fallbackToSelect: false
        });
    }

    function observeLearningUnitTopicPicker() {
        if (!getE2eConfig()) {
            return;
        }

        var pickerObserver = null;
        var observedPicker = null;

        function observePicker() {
            var select = document.querySelector('#topic_id.selectpicker');
            var picker = getBootstrapSelect(select);

            if (typeof MutationObserver === 'undefined' || !picker || picker === observedPicker) {
                return;
            }

            if (pickerObserver) {
                pickerObserver.disconnect();
            }

            observedPicker = picker;
            pickerObserver = new MutationObserver(function () {
                annotateLearningUnitTopicPicker();
            });

            pickerObserver.observe(picker, {
                attributes: true,
                attributeFilter: ['class', 'style', 'aria-hidden'],
                childList: true,
                subtree: true
            });
        }

        function annotateAndObservePicker() {
            var annotated = annotateLearningUnitTopicPicker();

            if (annotated) {
                observePicker();
            }

            return annotated;
        }

        annotateAndObservePicker();

        retryUntil(annotateAndObservePicker, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof $ !== 'undefined') {
            $('#topic_id.selectpicker').on(
                'loaded.bs.select rendered.bs.select refreshed.bs.select shown.bs.select changed.bs.select',
                annotateAndObservePicker
            );
        }
    }

    function annotateBackendSeminarFormSelects() {
        var testIds = getTestIds('learning_unit');
        var seminarForm = document.getElementById('seminar-form');

        if (!testIds || !seminarForm) {
            return false;
        }

        annotateBootstrapSelect('#seminar-form #certificate_id.selectpicker', {
            select: testIds.certificate_select,
            fallbackToSelect: false
        });
        annotateBootstrapSelect('#seminar-form #typeSelect.selectpicker', {
            select: testIds.seminar_completion_type_select,
            fallbackToSelect: false
        });
        annotateBootstrapSelect('#seminar-form #test_id.selectpicker', {
            select: testIds.seminar_test_select,
            fallbackToSelect: false
        });

        return true;
    }

    function observeBackendSeminarFormSelects() {
        var seminarForm = document.getElementById('seminar-form');

        if (!getE2eConfig() || !seminarForm) {
            return;
        }

        annotateBackendSeminarFormSelects();

        retryUntil(annotateBackendSeminarFormSelects, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver !== 'undefined') {
            new MutationObserver(function () {
                annotateBackendSeminarFormSelects();
            }).observe(seminarForm, {
                childList: true,
                subtree: true
            });
        }

        if (typeof $ !== 'undefined') {
            $('#certificate_id.selectpicker, #typeSelect.selectpicker, #test_id.selectpicker').on(
                'loaded.bs.select rendered.bs.select refreshed.bs.select shown.bs.select changed.bs.select',
                annotateBackendSeminarFormSelects
            );
        }
    }

    function annotateAdminSeminarMeetingForm() {
        var testIds = getTestIds('admin_seminar_meeting_form');

        if (!testIds) {
            return false;
        }

        testIds.status_select = testIds.status_select || 'admin-seminar-meeting-status-select';
        testIds.settings_tab = testIds.settings_tab || 'admin-seminar-meeting-settings-tab';
        testIds.min_participants_section = testIds.min_participants_section
            || 'admin-seminar-meeting-min-participants-section';
        testIds.min_participants_input = testIds.min_participants_input || 'admin-seminar-meeting-min-participants-input';
        testIds.min_participants_creator_notify_days_input = testIds.min_participants_creator_notify_days_input
            || 'admin-seminar-meeting-min-participants-creator-notify-days-input';
        testIds.min_participants_auto_cancel_control = testIds.min_participants_auto_cancel_control
            || 'admin-seminar-meeting-min-participants-auto-cancel-control';
        testIds.min_participants_auto_cancel_days_input = testIds.min_participants_auto_cancel_days_input
            || 'admin-seminar-meeting-min-participants-auto-cancel-days-input';
        testIds.instructors_table = testIds.instructors_table || 'admin-seminar-meeting-instructors-table';
        testIds.instructor_row = testIds.instructor_row || 'admin-seminar-meeting-instructor-row';
        testIds.instructor_status_cell = testIds.instructor_status_cell
            || 'admin-seminar-meeting-instructor-status-cell';
        testIds.instructor_acceptance_required_control = testIds.instructor_acceptance_required_control
            || 'admin-seminar-meeting-instructor-acceptance-required-control';
        testIds.instructor_empty_slot_indicator = testIds.instructor_empty_slot_indicator
            || 'admin-seminar-meeting-instructor-empty-slot-indicator';

        var meetingForm = document.getElementById('meeting-form');
        var meetingTabs = document.getElementById('meeting-tabs');

        if (!meetingForm && !meetingTabs) {
            return false;
        }

        setDataTestId(document.getElementById('start-date'), testIds.start_input);
        setDataTestId(document.getElementById('end-date'), testIds.end_input);
        setDataTestId(document.querySelector('#settings_tab a'), testIds.settings_tab);
        setDataTestId(
            document.querySelector('[data-testid="admin-seminar-meeting-min-participants-section"]')
                || document.getElementById('min_registrations')
                    && document.getElementById('min_registrations').closest('fieldset'),
            testIds.min_participants_section
        );
        setDataTestId(document.getElementById('min_registrations'), testIds.min_participants_input);
        setDataTestId(
            document.getElementById('notify_insufficient_registrations_days_before'),
            testIds.min_participants_creator_notify_days_input
        );
        var autoCancelInput = document.getElementById('cancel_insufficient_registrations_days_before');
        var autoCancelControl = autoCancelInput
            ? autoCancelInput.closest('[data-testid="admin-seminar-meeting-min-participants-auto-cancel-control"]')
                || autoCancelInput.parentElement
            : null;

        setDataTestId(autoCancelControl, testIds.min_participants_auto_cancel_control);
        setDataTestId(
            autoCancelInput,
            testIds.min_participants_auto_cancel_days_input
        );
        setDataTestId(document.querySelector('#meeting_instructors_tab a'), testIds.instructors_tab);
        setDataTestId(document.querySelector('#rooms_tab a'), testIds.rooms_tab);
        setDataTestId(document.querySelector('#messages_tab a'), testIds.system_messages_tab);

        if (document.getElementById('backend-meetings-edit-form-container')) {
            var notificationModal = document.getElementById('participantsNotificationModal');

            setDataTestId(
                notificationModal
                    ? notificationModal.querySelector('button[onclick^="rejectMeetingParticipantsNotification"]')
                    : null,
                testIds.participant_notification_no_button
            );
        }

        annotateBootstrapSelect('#type', {
            select: testIds.type_select
        });
        annotateBootstrapSelect('#status', {
            select: testIds.status_select,
            nativeSelect: true
        });
        annotateBootstrapSelect('#instructor_id', {
            select: testIds.instructor_select,
            search: testIds.instructor_search,
            option: testIds.instructor_option,
            nameAttribute: 'data-instructor-name'
        });
        annotateBootstrapSelect('#location_id', {
            select: testIds.location_select,
            option: testIds.location_option,
            nameAttribute: 'data-location-name'
        });
        annotateBootstrapSelect('#room_id', {
            select: testIds.room_select,
            option: testIds.room_option,
            nameAttribute: 'data-room-name'
        });
        annotateAdminSeminarMeetingInstructors(testIds);

        return true;
    }

    function getDataTableRowData(table, row) {
        if (typeof $ === 'undefined' || !$.fn || !$.fn.dataTable || !$.fn.dataTable.isDataTable(table)) {
            return null;
        }

        try {
            return $(table).DataTable().row(row).data();
        } catch (error) {
            return null;
        }
    }

    function annotateAdminSeminarMeetingInstructors(testIds) {
        var table = document.getElementById('meeting_instructors_datatable');

        if (!table || !testIds) {
            return false;
        }

        setDataTestId(table, testIds.instructors_table);

        var rows = table.querySelectorAll('tbody > tr');
        var annotatedRows = 0;

        for (var i = 0; i < rows.length; i++) {
            var emptyCell = rows[i].querySelector('td.dataTables_empty');

            if (emptyCell) {
                setDataTestId(emptyCell, testIds.instructor_empty_slot_indicator);
                continue;
            }

            var rowData = getDataTableRowData(table, rows[i]);
            var cells = rows[i].children;
            var name = rowData && rowData.full_name ? rowData.full_name : getText(cells[0]);
            var id = rowData && rowData.id ? rowData.id : null;
            var statusCell = cells.length > 3 ? cells[3] : null;
            var statusSelect = statusCell ? statusCell.querySelector('select.status-select') : null;

            setDataTestId(rows[i], testIds.instructor_row);
            setDataAttribute(rows[i], 'data-instructor-name', name);
            setDataAttribute(rows[i], 'data-instructor-id', id);
            setDataTestId(statusCell, testIds.instructor_status_cell);

            if (statusSelect) {
                setDataTestId(statusSelect, testIds.instructor_acceptance_required_control);
                setDataAttribute(statusSelect, 'data-instructor-name', name);
                setDataAttribute(statusSelect, 'data-instructor-id', id || statusSelect.getAttribute('data-id'));
                setDataAttribute(statusCell, 'data-instructor-status', statusSelect.value);
            }

            annotatedRows++;
        }

        return annotatedRows > 0;
    }

    function observeAdminSeminarMeetingForm() {
        if (!getE2eConfig()) {
            return;
        }

        var formObserver = null;
        var observedRoot = null;

        function getFormRoot() {
            return document.getElementById('meeting-form') || document.getElementById('meeting-tabs');
        }

        function observeFormRoot() {
            if (typeof MutationObserver === 'undefined') {
                return;
            }

            var formRoot = getFormRoot();

            if (!formRoot || formRoot === observedRoot) {
                return;
            }

            if (formObserver) {
                formObserver.disconnect();
            }

            observedRoot = formRoot;
            formObserver = new MutationObserver(function () {
                annotateAdminSeminarMeetingForm();
            });

            formObserver.observe(formRoot, {
                childList: true,
                subtree: true
            });
        }

        function annotateAndObserveForm() {
            var annotated = annotateAdminSeminarMeetingForm();

            if (annotated) {
                observeFormRoot();
            }

            return annotated;
        }

        var initialRoot = getFormRoot();

        if (!initialRoot) {
            return;
        }

        annotateAndObserveForm();

        retryUntil(annotateAndObserveForm, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        var pageRoot = initialRoot.parentElement || initialRoot;

        var pageObserver = new MutationObserver(function () {
            annotateAndObserveForm();
        });

        pageObserver.observe(pageRoot, {
            childList: true,
            subtree: true
        });

        if (typeof $ !== 'undefined') {
            $('#status').on(
                'loaded.bs.select rendered.bs.select refreshed.bs.select shown.bs.select changed.bs.select',
                annotateAndObserveForm
            );
        }
    }

    function annotateAdminSeminarGroupAssignment() {
        var testIds = getTestIds('admin_seminar_group_assignment');
        var modal = document.getElementById('assignToGroupModal');
        var meetingsTable = document.getElementById('meetings');

        if (!testIds || !meetingsTable) {
            return false;
        }

        setDataTestId(document.querySelector('button[onclick^="showUnitToGroupModal"]'), testIds.button);
        setDataTestId(modal, testIds.modal);

        annotateBootstrapSelect('#unit_groups', {
            select: testIds.select,
            option: testIds.option,
            nameAttribute: 'data-group-name'
        });

        if (modal) {
            setDataTestId(modal.querySelector('button[onclick^="saveUnitGroupAssignment"]'), testIds.save);
        }

        return !!modal || !!document.querySelector('button[onclick^="showUnitToGroupModal"]');
    }

    function observeAdminSeminarGroupAssignment() {
        var modal = document.getElementById('assignToGroupModal');
        var meetingsTable = document.getElementById('meetings');

        if (!getE2eConfig() || !modal || !meetingsTable) {
            return;
        }

        annotateAdminSeminarGroupAssignment();

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        var observer = new MutationObserver(function () {
            annotateAdminSeminarGroupAssignment();
        });

        observer.observe(modal, {
            childList: true,
            subtree: true
        });
    }

    function annotateAdminUserDetail() {
        var testIds = getAdminUserDetailTestIds();
        var modal = document.getElementById('connect_account_modal');

        if (!testIds || !modal) {
            return false;
        }

        annotateBootstrapSelect('#connect-account-dropdown', {
            select: testIds.existing_account_select,
            search: testIds.existing_account_search,
            option: testIds.existing_account_option
        });

        return true;
    }

    function annotateBackendToasts() {
        var testIds = getAdminUserDetailTestIds();
        var toasts;

        if (!testIds || !testIds.toast || !document.getElementById('connect_account_modal')) {
            return false;
        }

        toasts = document.querySelectorAll('.notification-message');

        for (var i = 0; i < toasts.length; i++) {
            setDataTestId(toasts[i], testIds.toast);
        }

        return toasts.length > 0;
    }

    function observeAdminUserDetail() {
        var modal = document.getElementById('connect_account_modal');
        var observedRoot;
        var observer;
        var pickerObserver;
        var observedPicker;

        if (!getE2eConfig() || !modal) {
            return;
        }

        annotateAdminUserDetail();

        retryUntil(annotateAdminUserDetail, {
            maxAttempts: 30,
            interval: 250
        });

        function observePicker() {
            var select = document.getElementById('connect-account-dropdown');
            var picker = getBootstrapSelect(select);

            if (typeof MutationObserver === 'undefined' || !picker || picker === observedPicker) {
                return;
            }

            if (pickerObserver) {
                pickerObserver.disconnect();
            }

            observedPicker = picker;
            pickerObserver = new MutationObserver(function () {
                annotateAdminUserDetail();
            });

            pickerObserver.observe(picker, {
                attributes: true,
                attributeFilter: ['class', 'style', 'aria-hidden'],
                childList: true,
                subtree: true
            });
        }

        if (typeof $ !== 'undefined') {
            $(modal).on('shown.bs.modal', function () {
                annotateAdminUserDetail();
                observePicker();
            });

            $('#connect-account-dropdown').on(
                'loaded.bs.select rendered.bs.select refreshed.bs.select shown.bs.select changed.bs.select',
                function () {
                    annotateAdminUserDetail();
                    observePicker();
                }
            );
        }

        observePicker();

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        observedRoot = modal.parentElement || modal;

        if (!observedRoot) {
            return;
        }

        observer = new MutationObserver(function () {
            annotateAdminUserDetail();
            observePicker();
        });

        observer.observe(observedRoot, {
            childList: true,
            subtree: true
        });
    }

    function observeBackendToasts() {
        var modal = document.getElementById('connect_account_modal');
        var notificationContainer = document.getElementById('notification-container');
        var observer;

        if (!getE2eConfig() || !modal || !notificationContainer) {
            return;
        }

        annotateBackendToasts();

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        observer = new MutationObserver(function () {
            annotateBackendToasts();
        });

        observer.observe(notificationContainer, {
            childList: true,
            subtree: true
        });
    }

    function getUserIdFromAction(action) {
        var row = action ? action.closest('tr[data-id]') : null;
        var onclick = action ? action.getAttribute('onclick') || '' : '';
        var match;

        if (row && row.getAttribute('data-id')) {
            return row.getAttribute('data-id');
        }

        match = onclick.match(/(?:addUser|showAddUserModal)\s*\(\s*[^,]+,\s*'?(\d+)'?/);

        return match ? match[1] : '';
    }

    function isShowAddUserModalWaitlistAction(onclick) {
        return /showAddUserModal\s*\([^)]*,\s*true\s*,/.test(onclick);
    }

    function isShowAddUserModalAddAction(onclick) {
        return /showAddUserModal\s*\([^)]*,\s*false\s*,/.test(onclick);
    }

    function isAdminUserEditAction(action) {
        var href = action ? action.getAttribute('href') || '' : '';

        return /\/admin\/users\/\d+\/?$/.test(href);
    }

    function annotateAdminGroupUsers() {
        var e2e = getE2eConfig();
        var testIds = getTestIds('groups');
        var groupContent = document.getElementById('group_content');
        var possibleTable = document.getElementById('possible_user_table');
        var assignedTable = document.getElementById('user_table');
        var possibleConditionTable = document.getElementById('possible_condition_table');
        var currentConditionTable = document.getElementById('condition_table');
        var possibleUnitTables = groupContent
            ? groupContent.querySelectorAll('table[id^="possible_"][id$="_table"]')
            : [];
        var annotated = false;
        var i;

        if (!testIds || !isGroupsPage(e2e)) {
            return false;
        }

        testIds.current_unit_remove_action = testIds.current_unit_remove_action || 'backend-groups-current-unit-remove-action';
        testIds.current_unit_visibility_action = testIds.current_unit_visibility_action || 'backend-groups-current-unit-visibility-action';

        if (possibleTable) {
            var possibleCheckboxes = possibleTable.querySelectorAll(
                'tbody input.user_curr_checkbox[type="checkbox"]'
            );
            var possibleActions = possibleTable.querySelectorAll('tbody button[onclick]');

            for (i = 0; i < possibleCheckboxes.length; i++) {
                setDataTestId(possibleCheckboxes[i], testIds.possible_user_select_checkbox);
                annotated = true;
            }

            for (i = 0; i < possibleActions.length; i++) {
                if ((possibleActions[i].getAttribute('onclick') || '').indexOf("addUnit('.addusers'") !== -1) {
                    setDataTestId(possibleActions[i], testIds.possible_user_add_action);
                    annotated = true;
                }
            }
        }

        if (possibleConditionTable) {
            var possibleConditionActions = possibleConditionTable.querySelectorAll('tbody button[onclick]');

            for (i = 0; i < possibleConditionActions.length; i++) {
                if ((possibleConditionActions[i].getAttribute('onclick') || '').indexOf("addUnit('.addconditions'") !== -1) {
                    setDataTestId(possibleConditionActions[i], testIds.possible_condition_add_action);
                    annotated = true;
                }
            }
        }

        for (i = 0; i < possibleUnitTables.length; i++) {
            if (
                possibleUnitTables[i].id === 'possible_user_table'
                || possibleUnitTables[i].id === 'possible_condition_table'
            ) {
                continue;
            }

            var possibleUnitActions = possibleUnitTables[i].querySelectorAll('tbody button[onclick]');

            for (var j = 0; j < possibleUnitActions.length; j++) {
                var possibleUnitOnclick = possibleUnitActions[j].getAttribute('onclick') || '';

                if (/^\s*addUnit\s*\(/.test(possibleUnitOnclick)) {
                    setDataTestId(possibleUnitActions[j], testIds.possible_unit_add_action);
                    annotated = true;
                }
            }
        }

        if (currentConditionTable) {
            var currentConditionCheckboxes = currentConditionTable.querySelectorAll(
                'tbody input.condition_poss_checkbox[type="checkbox"]'
            );
            var currentConditionActions = currentConditionTable.querySelectorAll('tbody button[onclick]');

            for (i = 0; i < currentConditionCheckboxes.length; i++) {
                setDataTestId(currentConditionCheckboxes[i], testIds.current_condition_select_checkbox);
                annotated = true;
            }

            for (i = 0; i < currentConditionActions.length; i++) {
                if ((currentConditionActions[i].getAttribute('onclick') || '').indexOf("removeUnit('.removecondition'") !== -1) {
                    setDataTestId(currentConditionActions[i], testIds.current_condition_remove_action);
                    annotated = true;
                }
            }
        }

        if (assignedTable) {
            var assignedCheckboxes = assignedTable.querySelectorAll(
                'tbody input.user_curr_checkbox[type="checkbox"]'
            );
            var assignedActions = assignedTable.querySelectorAll(
                'tbody button[onclick], tbody a[href*="/admin/users/"]'
            );

            for (i = 0; i < assignedCheckboxes.length; i++) {
                setDataTestId(assignedCheckboxes[i], testIds.assigned_user_select_checkbox);
                annotated = true;
            }

            for (i = 0; i < assignedActions.length; i++) {
                var onclick = assignedActions[i].getAttribute('onclick') || '';

                if (onclick.indexOf("removeUnit('.removeuser'") !== -1) {
                    setDataTestId(assignedActions[i], testIds.assigned_user_remove_action);
                    annotated = true;
                } else if (isAdminUserEditAction(assignedActions[i])) {
                    setDataTestId(assignedActions[i], testIds.assigned_user_edit_action);
                    annotated = true;
                }
            }
        }

        var currentUnitTables = groupContent
            ? groupContent.querySelectorAll('table[id$="_table"]:not([id^="possible_"]):not(#user_table):not(#condition_table)')
            : [];

        for (i = 0; i < currentUnitTables.length; i++) {
            var currentUnitActions = currentUnitTables[i].querySelectorAll('tbody button[onclick]');

            for (var k = 0; k < currentUnitActions.length; k++) {
                if (/^\s*setUnitVisibility\s*\(/.test(currentUnitActions[k].getAttribute('onclick') || '')) {
                    setDataTestId(currentUnitActions[k], testIds.current_unit_visibility_action);
                    annotated = true;
                }
            }
        }

        var currentSeminarTable = document.getElementById('seminar_table');

        if (currentSeminarTable) {
            var currentSeminarActions = currentSeminarTable.querySelectorAll('tbody button[onclick]');

            for (i = 0; i < currentSeminarActions.length; i++) {
                if ((currentSeminarActions[i].getAttribute('onclick') || '').indexOf("removeUnit('.removeseminar'") !== -1) {
                    setDataTestId(currentSeminarActions[i], testIds.current_unit_remove_action);
                    annotated = true;
                }
            }
        }

        return annotated;
    }

    function observeAdminGroupUsers() {
        var e2e = getE2eConfig();
        var groupContent = document.getElementById('group_content');
        var possibleTableObserver = null;
        var assignedTableObserver = null;
        var observedPossibleTable = null;
        var observedAssignedTable = null;

        if (!e2e || !isGroupsPage(e2e) || !groupContent) {
            return;
        }

        function refreshTableObservers() {
            var possibleTable = document.getElementById('possible_user_table');
            var assignedTable = document.getElementById('user_table');

            if (possibleTable !== observedPossibleTable) {
                if (possibleTableObserver) {
                    possibleTableObserver.disconnect();
                }

                observedPossibleTable = possibleTable;
                possibleTableObserver = null;

                if (possibleTable && typeof MutationObserver !== 'undefined') {
                    possibleTableObserver = new MutationObserver(function () {
                        annotateAdminGroupUsers();
                    });

                    possibleTableObserver.observe(possibleTable, {
                        childList: true,
                        subtree: true
                    });
                }
            }

            if (assignedTable !== observedAssignedTable) {
                if (assignedTableObserver) {
                    assignedTableObserver.disconnect();
                }

                observedAssignedTable = assignedTable;
                assignedTableObserver = null;

                if (assignedTable && typeof MutationObserver !== 'undefined') {
                    assignedTableObserver = new MutationObserver(function () {
                        annotateAdminGroupUsers();
                    });

                    assignedTableObserver.observe(assignedTable, {
                        childList: true,
                        subtree: true
                    });
                }
            }

            return annotateAdminGroupUsers();
        }

        refreshTableObservers();

        retryUntil(refreshTableObservers, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            refreshTableObservers();
        }).observe(groupContent, {
            childList: true,
            subtree: true
        });
    }

    function annotateAdminUsersIndex() {
        var testIds = getTestIds('users');
        var container = document.getElementById('users-table-container');
        var table = container ? container.querySelector('#table') : null;
        var modal = document.getElementById('user-groups');
        var annotated = false;
        var actions;
        var modalBody;

        if (!testIds || !table || !modal) {
            return false;
        }

        actions = table.querySelectorAll(
            'tbody button[onclick], tbody a[href*="/admin/users/"]'
        );

        for (var i = 0; i < actions.length; i++) {
            var onclick = actions[i].getAttribute('onclick') || '';

            if (/\bgetGroups\s*\(/.test(onclick)) {
                setDataTestId(actions[i], testIds.table_action_groups);
                annotated = true;
            } else if (isAdminUserEditAction(actions[i])) {
                setDataTestId(actions[i], testIds.table_action_edit);
                annotated = true;
            }
        }

        modalBody = modal.querySelector('.modal-body');

        if (modalBody) {
            setDataTestId(modalBody, testIds.groups_modal_body);
            annotated = true;
        }

        return annotated;
    }

    function observeAdminUsersIndex() {
        var container = document.getElementById('users-table-container');
        var table = container ? container.querySelector('#table') : null;
        var modal = document.getElementById('user-groups');

        if (!getE2eConfig() || !table || !modal) {
            return;
        }

        annotateAdminUsersIndex();

        retryUntil(annotateAdminUsersIndex, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            annotateAdminUsersIndex();
        }).observe(table, {
            childList: true,
            subtree: true
        });

        new MutationObserver(function () {
            annotateAdminUsersIndex();
        }).observe(modal, {
            childList: true,
            subtree: true
        });
    }

    function annotateCourseStatisticsProgress() {
        var testIds = getTestIds('statistics');
        var path = window.location.pathname.replace(/\/+$/, '');
        var table = document.querySelector('.statistics-table-wrapper #table');
        var progressCircles;
        var actions;
        var annotated = false;

        if (!testIds || path !== '/admin/statistics/courses' || !table) {
            return false;
        }

        progressCircles = table.querySelectorAll('tbody svg-progress-circle');
        actions = table.querySelectorAll('tbody button[onclick]');

        for (var i = 0; i < progressCircles.length; i++) {
            setDataTestId(progressCircles[i], testIds.course_progress);
            annotated = true;
        }

        for (var j = 0; j < actions.length; j++) {
            var onclick = actions[j].getAttribute('onclick') || '';

            if (/\bconfirmCompletingScormData\s*\(/.test(onclick)) {
                setDataTestId(actions[j], testIds.course_action_complete);
                annotated = true;
            } else if (/\bconfirmDeletingScormData\s*\(/.test(onclick)) {
                setDataTestId(actions[j], testIds.course_action_reset_progress);
                annotated = true;
            }
        }

        return annotated;
    }

    function observeCourseStatisticsProgress() {
        var path = window.location.pathname.replace(/\/+$/, '');
        var table = document.querySelector('.statistics-table-wrapper #table');

        if (!getE2eConfig() || path !== '/admin/statistics/courses' || !table) {
            return;
        }

        annotateCourseStatisticsProgress();

        retryUntil(annotateCourseStatisticsProgress, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            annotateCourseStatisticsProgress();
        }).observe(table, {
            childList: true,
            subtree: true
        });
    }

    function isBackendCourseEditAction(action) {
        var href = action.getAttribute('href') || '';

        return /^\/admin\/course\/\d+\/?$/.test(href);
    }

    function annotateBackendCoursesIndex() {
        var testIds = getTestIds('courses');
        var path = window.location.pathname.replace(/\/+$/, '');
        var table = document.getElementById('active-table');
        var actions;

        if (!testIds || path !== '/admin/course' || !table) {
            return false;
        }

        actions = table.querySelectorAll('tbody a[href*="/admin/course/"]');

        for (var i = 0; i < actions.length; i++) {
            if (isBackendCourseEditAction(actions[i])) {
                setDataTestId(actions[i], testIds.table_action_edit);
            }
        }

        return actions.length > 0;
    }

    function observeBackendCoursesIndex() {
        var path = window.location.pathname.replace(/\/+$/, '');
        var table = document.getElementById('active-table');

        if (!getE2eConfig() || path !== '/admin/course' || !table) {
            return;
        }

        annotateBackendCoursesIndex();

        retryUntil(annotateBackendCoursesIndex, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            annotateBackendCoursesIndex();
        }).observe(table, {
            childList: true,
            subtree: true
        });
    }

    function annotateBackendSeminarDuplicationControls() {
        var testIds = getTestIds('learning_unit');
        var path = window.location.pathname.replace(/\/+$/, '');
        var table = document.getElementById('active-table');
        var modal = document.getElementById('duplicateModal');
        var actions;
        var confirmButtons;
        var actionAnnotated = false;
        var confirmAnnotated = false;

        if (!testIds || path !== '/admin/seminar' || !table || !modal) {
            return false;
        }

        actions = table.querySelectorAll('tbody button[onclick]');

        for (var i = 0; i < actions.length; i++) {
            var actionOnclick = actions[i].getAttribute('onclick') || '';

            if (/^\s*confirmUnitDuplication\s*\(\s*['"]seminar['"]\s*,/.test(actionOnclick)) {
                setDataTestId(actions[i], testIds.duplicate_action);
                actionAnnotated = true;
            }
        }

        setDataTestId(modal, testIds.duplicate_modal);
        confirmButtons = modal.querySelectorAll('.modal-footer button.btn.positive[onclick]');

        for (var j = 0; j < confirmButtons.length; j++) {
            var confirmOnclick = confirmButtons[j].getAttribute('onclick') || '';

            if (/^\s*duplicateUnit\s*\(\s*\)/.test(confirmOnclick)) {
                setDataTestId(confirmButtons[j], testIds.duplicate_confirm_button);
                confirmAnnotated = true;
                break;
            }
        }

        return actionAnnotated && confirmAnnotated;
    }

    function observeBackendSeminarDuplicationControls() {
        var path = window.location.pathname.replace(/\/+$/, '');
        var table = document.getElementById('active-table');

        if (!getE2eConfig() || path !== '/admin/seminar' || !table) {
            return;
        }

        annotateBackendSeminarDuplicationControls();

        retryUntil(annotateBackendSeminarDuplicationControls, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            annotateBackendSeminarDuplicationControls();
        }).observe(table, {
            childList: true,
            subtree: true
        });
    }

    function annotateBackendCourseScormDetail() {
        var testIds = getTestIds('courses');
        var path = window.location.pathname.replace(/\/+$/, '');
        var editAction;

        if (!testIds || !/^\/admin\/course\/\d+$/.test(path)) {
            return false;
        }

        editAction = document.querySelector(
            'a[href*="/admin/scorm/"][href$="/edit"]'
        );
        setDataTestId(editAction, testIds.scorm_edit_action);

        return !!editAction;
    }

    function annotateBackendMediaPreview() {
        var testIds = getTestIds('content_media');
        var dialog = document.getElementById('media');
        var player;
        var closeButton;

        if (!testIds
            || !dialog
            || dialog.getAttribute('data-testid') !== testIds.preview_dialog
        ) {
            return false;
        }

        player = dialog.querySelector('video#mediaItem, audio#mediaItem');
        closeButton = dialog.querySelector('#closeMedia');

        setDataTestId(player, testIds.preview_player);
        setDataTestId(closeButton, testIds.preview_close_button);

        return !!player && !!closeButton;
    }

    function observeBackendMediaPreview() {
        var testIds = getTestIds('content_media');
        var dialog = document.getElementById('media');

        if (!testIds
            || !dialog
            || dialog.getAttribute('data-testid') !== testIds.preview_dialog
        ) {
            return;
        }

        annotateBackendMediaPreview();

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            annotateBackendMediaPreview();
        }).observe(dialog, {
            childList: true,
            subtree: true
        });
    }

    function annotateBackendCourseDeleteConfirmation() {
        var testIds = getTestIds('courses');
        var deleteTrigger = document.querySelector('[data-testid="backend-course-delete-action"]');
        var modal = document.getElementById('deleteModal');
        var confirmButtons;

        if (!testIds || !deleteTrigger || !modal) {
            return false;
        }

        confirmButtons = modal.querySelectorAll('.modal-footer button.btn.positive[onclick]');

        for (var i = 0; i < confirmButtons.length; i++) {
            var onclick = confirmButtons[i].getAttribute('onclick') || '';

            if (/^\s*deleteAction\s*\(\s*\)\s*;?\s*$/.test(onclick)) {
                setDataTestId(confirmButtons[i], testIds.delete_confirm_button);
                return true;
            }
        }

        return false;
    }

    function annotateBackendCourseCreateVersionConfirmation() {
        var testIds = getTestIds('courses');
        var createVersionTrigger = document.querySelector('[data-testid="backend-course-create-version-button"]');
        var modal = document.getElementById('createModal');
        var confirmButtons;

        if (!testIds || !createVersionTrigger || !modal) {
            return false;
        }

        confirmButtons = modal.querySelectorAll('.modal-footer button.btn.positive[onclick]');

        for (var i = 0; i < confirmButtons.length; i++) {
            var onclick = confirmButtons[i].getAttribute('onclick') || '';

            if (/^\s*createCourseVersion\s*\(\s*\)\s*;?\s*$/.test(onclick)) {
                setDataTestId(confirmButtons[i], testIds.create_version_confirm_button);
                return true;
            }
        }

        return false;
    }

    function annotatePossibleMeetingParticipantAction(action, testIds) {
        var onclick = action.getAttribute('onclick') || '';

        if (onclick.indexOf('getBillingAddressesForUser') !== -1) {
            setDataTestId(action, testIds.book_action);
            return;
        }

        if (onclick.indexOf('enrollOnWaitlist') !== -1 || isShowAddUserModalWaitlistAction(onclick)) {
            setDataTestId(action, testIds.add_to_waitlist_action);
            return;
        }

        if (onclick.indexOf('addUser') !== -1 || isShowAddUserModalAddAction(onclick)) {
            setDataTestId(action, testIds.add_user_action);
            setDataAttribute(action, 'data-user-id', getUserIdFromAction(action));
            return;
        }

        if (isAdminUserEditAction(action)) {
            setDataTestId(action, testIds.edit_user_action);
        }
    }

    function annotateCurrentMeetingParticipantAction(action, testIds) {
        var onclick = action.getAttribute('onclick') || '';

        if (onclick.indexOf('openBookingDetails') !== -1) {
            setDataTestId(action, testIds.booking_details_action);
            return;
        }

        if (onclick.indexOf('removeUser(') !== -1 || onclick.indexOf('removeUserConfirm') !== -1) {
            setDataTestId(action, testIds.remove_user_action);
            return;
        }

        if (onclick.indexOf('deregisterConfirm') !== -1) {
            setDataTestId(action, testIds.deregister_action);
            return;
        }

        if (isAdminUserEditAction(action)) {
            setDataTestId(action, testIds.edit_user_action);
        }
    }

    function annotateAdminMeetingParticipantHeaders(testIds) {
        if (!getE2eConfig() || !document.getElementById('meeting-participants-tabs')
            || !window.jQuery || !window.jQuery.fn || !window.jQuery.fn.dataTable
            || typeof window.jQuery.fn.dataTable.isDataTable !== 'function') {
            return;
        }

        var tables = [
            { id: 'participants' },
            { id: 'ranklist_user_table', extra: 'points', testId: testIds.column_points },
            { id: 'waitlist_user_table', extra: 'position', testId: testIds.column_waitlist_position }
        ];

        tables.forEach(function (table) {
            var element = document.getElementById(table.id);
            if (!element || !window.jQuery.fn.dataTable.isDataTable(element)) {
                return;
            }

            // Read the application's existing column identity; never initialize or redraw a table.
            var api = window.jQuery(element).DataTable();
            api.columns().every(function () {
                var source = this.dataSrc();
                var testId = source === 'id' ? testIds.column_user_id
                    : source === 'email' ? testIds.column_email
                    : table.extra && source === table.extra ? table.testId : null;
                setDataTestId(this.header(), testId);
            });
        });
    }

    function annotateAdminMeetingParticipantTableControls(testIds) {
        var controls = [
            {
                loaderSelector: '#participants_container_loader',
                paginationSelector: '#participants_wrapper .dt-paging',
                pageInputSelector: '#participants_wrapper .jump-to-page',
                loaderTestId: testIds.current_users_loader,
                paginationTestId: testIds.current_users_pagination,
                pageInputTestId: testIds.current_users_pagination_page_input
            },
            {
                loaderSelector: '#ranklist_user_table_container_loader',
                paginationSelector: '#ranklist_user_table_wrapper .dt-paging',
                pageInputSelector: '#ranklist_user_table_wrapper .jump-to-page',
                loaderTestId: testIds.ranklist_loader,
                paginationTestId: testIds.ranklist_pagination,
                pageInputTestId: testIds.ranklist_pagination_page_input
            },
            {
                loaderSelector: '#waitlist_user_table_container_loader',
                paginationSelector: '#waitlist_user_table_wrapper .dt-paging',
                pageInputSelector: '#waitlist_user_table_wrapper .jump-to-page',
                loaderTestId: testIds.waitlist_loader,
                paginationTestId: testIds.waitlist_pagination,
                pageInputTestId: testIds.waitlist_pagination_page_input
            }
        ];
        var annotated = false;

        for (var i = 0; i < controls.length; i++) {
            var loader = document.querySelector(controls[i].loaderSelector);
            var pagination = document.querySelector(controls[i].paginationSelector);
            var pageInput = document.querySelector(controls[i].pageInputSelector);

            setDataTestId(loader, controls[i].loaderTestId);
            setDataTestId(pagination, controls[i].paginationTestId);
            setDataTestId(pageInput, controls[i].pageInputTestId);

            annotated = annotated || !!loader || !!pagination || !!pageInput;
        }

        return annotated;
    }

    function annotateAdminMeetingParticipants() {
        var testIds = getTestIds('admin_meeting_participants') || {};
        var organizerTestIds = getTestIds('organizer_meeting_participants') || {};
        var isFrontendParticipantsPage = typeof backend !== 'undefined'
            && (backend === false || String(backend) === '' || String(backend) === 'false' || String(backend) === '0');
        var tabAndTableTestIds = isFrontendParticipantsPage ? organizerTestIds : testIds;
        var possibleTable = document.getElementById('possible_user_table');
        var currentParticipantsTable = document.getElementById('participants');
        var ranklistTable = document.getElementById('ranklist_user_table');
        var participationRequestsTable = document.getElementById('participation_requests_table');
        var waitlistTable = document.getElementById('waitlist_user_table');

        testIds.ranklist_users_tab = testIds.ranklist_users_tab || 'admin-meeting-participants-ranklist-users-tab';
        testIds.possible_users_table = testIds.possible_users_table
            || 'admin-meeting-participants-possible-users-table';
        testIds.ranklist_table = testIds.ranklist_table || 'admin-meeting-participants-ranklist-table';
        testIds.participation_requests_tab = testIds.participation_requests_tab || 'admin-meeting-participants-participation-requests-tab';
        testIds.participation_requests_table = testIds.participation_requests_table || 'admin-meeting-participants-participation-requests-table';
        testIds.waitlist_users_tab = testIds.waitlist_users_tab || 'admin-meeting-participants-waitlist-users-tab';
        testIds.waitlist_table = testIds.waitlist_table || 'admin-meeting-participants-waitlist-table';
        testIds.current_users_table = testIds.current_users_table || 'admin-meeting-participants-current-users-table';
        testIds.current_users_loader = testIds.current_users_loader || 'admin-meeting-participants-current-users-loader';
        testIds.current_users_pagination = testIds.current_users_pagination || 'admin-meeting-participants-current-users-pagination';
        testIds.current_users_pagination_page_input = testIds.current_users_pagination_page_input || 'admin-meeting-participants-current-users-pagination-page-input';
        testIds.ranklist_loader = testIds.ranklist_loader || 'admin-meeting-participants-ranklist-loader';
        testIds.ranklist_pagination = testIds.ranklist_pagination || 'admin-meeting-participants-ranklist-pagination';
        testIds.ranklist_pagination_page_input = testIds.ranklist_pagination_page_input || 'admin-meeting-participants-ranklist-pagination-page-input';
        testIds.waitlist_loader = testIds.waitlist_loader || 'admin-meeting-participants-waitlist-loader';
        testIds.waitlist_pagination = testIds.waitlist_pagination || 'admin-meeting-participants-waitlist-pagination';
        testIds.waitlist_pagination_page_input = testIds.waitlist_pagination_page_input || 'admin-meeting-participants-waitlist-pagination-page-input';
        testIds.approved_checkbox = testIds.approved_checkbox || 'admin-meeting-participants-approved-checkbox';
        testIds.deregister_reason_select = testIds.deregister_reason_select
            || 'admin-meeting-participants-deregister-reason-select';
        testIds.deregister_modal = testIds.deregister_modal
            || 'admin-meeting-participants-deregister-modal';
        testIds.deregister_confirm_button = testIds.deregister_confirm_button
            || 'admin-meeting-participants-deregister-confirm-button';

        if (tabAndTableTestIds) {
            tabAndTableTestIds.add_users_tab = tabAndTableTestIds.add_users_tab
                || (isFrontendParticipantsPage ? 'organizer-meeting-participants-add-users-tab' : testIds.add_users_tab);
            tabAndTableTestIds.possible_users_table = tabAndTableTestIds.possible_users_table
                || (isFrontendParticipantsPage ? 'organizer-meeting-participants-possible-users-table' : testIds.possible_users_table);
            tabAndTableTestIds.current_users_tab = tabAndTableTestIds.current_users_tab
                || (isFrontendParticipantsPage ? 'organizer-meeting-participants-current-users-tab' : testIds.current_users_tab);
            tabAndTableTestIds.current_users_table = tabAndTableTestIds.current_users_table
                || (isFrontendParticipantsPage ? 'organizer-meeting-participants-current-users-table' : testIds.current_users_table);
        }

        setDataTestId(document.querySelector('#possible_users_tab a'), tabAndTableTestIds.add_users_tab);
        setDataTestId(document.querySelector('#current_users_tab a'), tabAndTableTestIds.current_users_tab);
        setDataTestId(document.querySelector('#ranklist_users_tab a'), testIds.ranklist_users_tab);
        setDataTestId(document.querySelector('#participation_requests_tab a'), testIds.participation_requests_tab);
        setDataTestId(document.querySelector('#waitlist_users_tab a'), testIds.waitlist_users_tab);
        setDataTestId(possibleTable, tabAndTableTestIds.possible_users_table);
        setDataTestId(currentParticipantsTable, tabAndTableTestIds.current_users_table);
        setDataTestId(ranklistTable, testIds.ranklist_table);
        setDataTestId(participationRequestsTable, testIds.participation_requests_table);
        setDataTestId(waitlistTable, testIds.waitlist_table);

        annotateAdminMeetingParticipantHeaders(testIds);
        var tableControlsAnnotated = annotateAdminMeetingParticipantTableControls(testIds);

        if (possibleTable) {
            var actions = possibleTable.querySelectorAll(
                'tbody button[onclick], tbody a[onclick], tbody a[href*="/admin/users/"]'
            );

            for (var i = 0; i < actions.length; i++) {
                annotatePossibleMeetingParticipantAction(actions[i], testIds);
            }
        }

        if (currentParticipantsTable) {
            var currentActions = currentParticipantsTable.querySelectorAll(
                'tbody button[onclick], tbody a[onclick], tbody a[href*="/admin/users/"]'
            );

            for (var j = 0; j < currentActions.length; j++) {
                annotateCurrentMeetingParticipantAction(currentActions[j], testIds);
            }

            var attendedCheckboxes = currentParticipantsTable.querySelectorAll(
                'tbody input.tutorActions[data-type="attended"]'
            );

            for (var k = 0; k < attendedCheckboxes.length; k++) {
                setDataTestId(attendedCheckboxes[k], testIds.attended_checkbox);
            }

            var approvedCheckboxes = currentParticipantsTable.querySelectorAll(
                'tbody input.tutorActions[data-type="approved"], tbody input.tutorActions[data-type="passed"]'
            );

            for (var n = 0; n < approvedCheckboxes.length; n++) {
                setDataTestId(approvedCheckboxes[n], testIds.approved_checkbox);
            }

            var notPassedIcons = currentParticipantsTable.querySelectorAll(
                'tbody p[style*="color:red"] i.fa-times'
            );

            for (var l = 0; l < notPassedIcons.length; l++) {
                setDataTestId(notPassedIcons[l].closest('td'), testIds.test_not_passed_indicator);
            }

            var passedIcons = currentParticipantsTable.querySelectorAll(
                'tbody p[style*="color:green"] i.fa-check'
            );

            for (var m = 0; m < passedIcons.length; m++) {
                setDataTestId(passedIcons[m].closest('td'), testIds.test_passed_indicator);
            }
        }

        if (typeof canArchive !== 'undefined' && String(canArchive) === '1'
            && typeof isArchived !== 'undefined' && String(isArchived) !== '1') {
            setDataTestId(
                document.querySelector('#participants_wrapper .dt-buttons button.positive'),
                testIds.finalize_button
            );
        }

        var archiveModal = document.getElementById('archiveModal');

        setDataTestId(
            archiveModal ? archiveModal.querySelector('button[onclick^="archiveMeeting"]') : null,
            testIds.finalize_confirm_button
        );

        var modal = document.getElementById('combinedMeetingActionModal');

        setDataTestId(modal, testIds.combined_confirm_modal);

        if (modal) {
            setDataTestId(modal.querySelector('button[onclick="confirmCombinedMeetingAction()"]'), testIds.combined_confirm_yes);
            setDataTestId(modal.querySelector('button[onclick="rejectCombinedMeetingAction()"]'), testIds.combined_confirm_no);
            setDataTestId(modal.querySelector('button[onclick="cancelCombinedMeetingAction()"]'), testIds.combined_confirm_cancel);
        }

        var deregisterModal = document.getElementById('deregisterParticipantModal');

        if (deregisterModal) {
            setDataTestId(
                deregisterModal,
                testIds.deregister_modal
            );
            setDataTestId(
                deregisterModal.querySelector('#deregistration_reason'),
                testIds.deregister_reason_select
            );
            setDataTestId(
                deregisterModal.querySelector('#confirm_button'),
                testIds.deregister_confirm_button
            );
        }

        return !!document.getElementById('meeting-participants-tabs') || !!possibleTable || !!currentParticipantsTable || !!ranklistTable || !!participationRequestsTable || !!waitlistTable || tableControlsAnnotated || !!modal || !!deregisterModal;
    }

    function observeAdminMeetingParticipants() {
        if (!getE2eConfig() || !document.getElementById('meeting-participants-tabs')) {
            return;
        }

        annotateAdminMeetingParticipants();

        retryUntil(annotateAdminMeetingParticipants, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        var tabs = document.getElementById('meeting-participants-tabs');
        var participantsRoot = tabs.parentElement || tabs;
        var observer = new MutationObserver(function () {
            annotateAdminMeetingParticipants();
        });

        observer.observe(participantsRoot, {
            childList: true,
            subtree: true
        });
    }

    function annotateQrMeetingParticipation() {
        var testIds = getTestIds('qr_meeting_participation');
        var modal = document.getElementById('confirmParticipationModal');
        var redirectDataValue = typeof redirectData !== 'undefined' ? redirectData : null;

        if (!testIds || !modal || !redirectDataValue || typeof redirectDataValue !== 'object') {
            return false;
        }

        var hasParticipationRedirect = Object.prototype.hasOwnProperty.call(redirectDataValue, 'type')
            || Object.prototype.hasOwnProperty.call(redirectDataValue, 'info')
            || Object.prototype.hasOwnProperty.call(redirectDataValue, 'meeting');

        if (!hasParticipationRedirect) {
            return false;
        }

        testIds.confirm_button = testIds.confirm_button || 'qr-meeting-participation-confirm-button';
        testIds.status = testIds.status || 'qr-meeting-participation-status';
        testIds.error = testIds.error || 'qr-meeting-participation-error';

        setDataTestId(
            modal.querySelector('button[onclick^="confirmParticipation"]'),
            testIds.confirm_button
        );

        var info = modal.querySelector('#info');
        var hasMeeting = Object.prototype.hasOwnProperty.call(redirectDataValue, 'meeting')
            && redirectDataValue.meeting;

        setDataTestId(info, hasMeeting ? testIds.status : testIds.error);

        return !!info;
    }

    function observeQrMeetingParticipation() {
        if (!getE2eConfig() || !document.getElementById('confirmParticipationModal')) {
            return;
        }

        annotateQrMeetingParticipation();

        retryUntil(annotateQrMeetingParticipation, {
            maxAttempts: 20,
            interval: 250
        });
    }

    function annotateBackendCoursePublishModal() {
        var testIds = getTestIds('backend_course_publish');
        var modal = document.getElementById('publishModal');

        if (!testIds || !modal || !document.getElementById('course_overlay')) {
            return;
        }

        setDataTestId(modal, testIds.modal);
        setDataTestId(modal.querySelector('.modal-footer button.btn.positive'), testIds.confirm_button);
    }

    function annotateAdminUserDetailPromoteSuperAdminModal() {
        var testIds = getTestIds('admin_user_detail');
        var modal = document.getElementById('confirmSuperAdminModal');

        if (!testIds || !modal) {
            return;
        }

        setDataTestId(modal, testIds.promote_super_admin_modal);
        setDataTestId(modal.querySelector('#action_password'), testIds.promote_super_admin_password_input);
        setDataTestId(
            modal.querySelector('.modal-footer button.btn.positive'),
            testIds.promote_super_admin_confirm_button
        );
    }

    function annotateLearnerSeminarDeregisterModal() {
        var testIds = getTestIds('learner_seminar_deregister');
        var pageRoot = document.querySelector('[id^="meetings-container_"]');
        var modal = document.getElementById('deregisterParticipantModal');

        if (!testIds || !pageRoot || !modal) {
            return;
        }

        setDataTestId(modal, testIds.modal);
        setDataTestId(modal.querySelector('#deregistration_reason'), testIds.reason_select);
        setDataTestId(modal.querySelector('#confirm_button'), testIds.confirm_button);
    }

    function annotateSupervisorMandatoryUnits() {
        var testIds = getTestIds('supervisor_mandatory_units');
        var root = document.querySelector('[data-testid="mandatory-units-page"]');
        var table = root ? root.querySelector('#mandatory-widget') : null;
        var summaries;

        if (!testIds || !root || !table) {
            return false;
        }

        setDataTestId(table, testIds.table);
        summaries = table.querySelectorAll('tbody .progress-all');

        for (var i = 0; i < summaries.length; i++) {
            setDataTestId(summaries[i].querySelector('.badge.success'), testIds.summary_completed);
            setDataTestId(summaries[i].querySelector('.badge.warning'), testIds.summary_in_progress);
            setDataTestId(summaries[i].querySelector('.badge.danger'), testIds.summary_overdue);
        }

        return true;
    }

    function observeSupervisorMandatoryUnits() {
        var root = document.querySelector('[data-testid="mandatory-units-page"]');

        if (!getE2eConfig() || !root) {
            return;
        }

        annotateSupervisorMandatoryUnits();

        retryUntil(annotateSupervisorMandatoryUnits, {
            maxAttempts: 40,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            annotateSupervisorMandatoryUnits();
        }).observe(root, {
            childList: true,
            subtree: true
        });
    }

    function isAdminUserDetailPage() {
        return /^\/admin\/users\/\d+(?:\/[^/]+)?\/?$/.test(window.location.pathname);
    }

    function annotateAdminUserDetailLearningUnitSelectors() {
        var testIds = getTestIds('admin_user_detail');
        var scheduleModal;
        var scheduleTable;
        var rows;
        var deregisterModal;
        var certificateModal;
        var appointmentRowsAnnotated = 0;

        if (!testIds || !isAdminUserDetailPage()) {
            return false;
        }

        annotateBootstrapSelect('#not-assigned-learning-units', {
            select: testIds.assign_learning_unit_select
        });

        scheduleModal = document.getElementById('seriesInfoModal');
        setDataTestId(scheduleModal, testIds.seminar_schedule_modal);

        scheduleTable = document.querySelector(
            '#series_units_data_table_overview, '
            + '#seminar_units_data_table_overview'
        );
        rows = scheduleTable
            ? scheduleTable.querySelectorAll('tbody > tr:not(.child)')
            : [];

        for (var i = 0; i < rows.length; i++) {
            var cells = rows[i].children;

            if (cells.length < 2 || rows[i].querySelector('td.dataTables_empty')) {
                continue;
            }

            setDataTestId(rows[i], testIds.seminar_appointment);
            var actionCell = cells[cells.length - 1];
            var statusCell = cells[cells.length - 4];
            var registerAction = actionCell.querySelector(
                '[id="add_user"][data-origin="supervisor"]'
            );
            var deregisterAction = actionCell.querySelector(
                '[id="deregister_user"][data-origin="supervisor"], '
                + '.remove-user[data-origin="supervisor"]'
            );

            setDataTestId(
                statusCell,
                testIds.seminar_appointment_status
            );
            setDataTestId(
                registerAction,
                testIds.seminar_appointment_register_action
            );
            setDataTestId(
                deregisterAction,
                testIds.seminar_appointment_deregister_action
            );
            appointmentRowsAnnotated++;
        }

        deregisterModal = document.getElementById('deregisterParticipantModal');
        setDataTestId(deregisterModal, testIds.seminar_deregister_modal);

        if (deregisterModal) {
            setDataTestId(
                deregisterModal.querySelector('#deregistration_reason'),
                testIds.seminar_deregister_reason_select
            );
            setDataTestId(
                deregisterModal.querySelector('#confirm_button'),
                testIds.seminar_deregister_confirm_button
            );
        }

        certificateModal = document.getElementById('createCertificateModal');
        setDataTestId(certificateModal, testIds.add_certificate_modal);

        if (certificateModal) {
            setDataTestId(
                certificateModal.querySelector('#external_certificates_input'),
                testIds.add_certificate_name_input
            );
            setDataTestId(
                certificateModal.querySelector('#received_on'),
                testIds.add_certificate_completed_at_input
            );
            setDataTestId(
                certificateModal.querySelector('#expires_on'),
                testIds.add_certificate_valid_until_input
            );
            setDataTestId(
                certificateModal.querySelector('#certificate_file'),
                testIds.add_certificate_file_input
            );
            setDataTestId(
                certificateModal.querySelector('button[onclick^="createCertificate("]'),
                testIds.add_certificate_submit_button
            );
        }

        return appointmentRowsAnnotated > 0;
    }

    function observeAdminUserDetailLearningUnitSelectors() {
        var learningUnitsPanel = document.getElementById('learning_units');
        var scheduleModal = document.getElementById('seriesInfoModal');
        var scheduleContent = document.getElementById('series_units_data_table');

        if (!getE2eConfig() || !isAdminUserDetailPage()) {
            return;
        }

        function annotateScheduleTable() {
            return annotateAdminUserDetailLearningUnitSelectors();
        }

        annotateScheduleTable();

        retryUntil(annotateScheduleTable, {
            maxAttempts: 80,
            interval: 250
        });

        if (typeof $ !== 'undefined') {
            $(document).on(
                'shown.bs.modal',
                '#seriesInfoModal',
                annotateScheduleTable
            );
            $(document).on(
                'draw.dt',
                '#series_units_data_table_overview, '
                + '#seminar_units_data_table_overview',
                annotateScheduleTable
            );
        }

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        if (learningUnitsPanel) {
            new MutationObserver(function () {
                annotateScheduleTable();
            }).observe(learningUnitsPanel, {
                childList: true,
                subtree: true
            });
        }

        if (scheduleModal) {
            new MutationObserver(function () {
                annotateScheduleTable();
            }).observe(scheduleModal, {
                childList: true,
                subtree: true
            });
        }

        if (scheduleContent) {
            new MutationObserver(function () {
                annotateScheduleTable();
            }).observe(scheduleContent, {
                childList: true,
                subtree: true
            });
        }
    }

    function annotateAdminUserDetailLearningHistorySelectors() {
        var testIds = getTestIds('admin_user_detail');
        var learningHistoryPanel = document.getElementById('learningoverview');
        var typeColumn;
        var statusSelectAnnotated = false;

        if (!testIds || !isAdminUserDetailPage()) {
            return false;
        }

        typeColumn = document.querySelector(
            '#table_learning_overview thead th:nth-child(2)'
        );
        setDataTestId(typeColumn, testIds.learning_history_column_type);

        if (learningHistoryPanel && learningHistoryPanel.querySelector('#status_select')) {
            statusSelectAnnotated = annotateBootstrapSelect('#learningoverview #status_select', {
                select: testIds.learning_history_status_select,
                nativeSelect: true
            });
        }

        return !!typeColumn || statusSelectAnnotated;
    }

    function observeAdminUserDetailLearningHistorySelectors() {
        var learningHistoryPanel = document.getElementById('learningoverview');

        if (!getE2eConfig() || !isAdminUserDetailPage() || !learningHistoryPanel) {
            return;
        }

        annotateAdminUserDetailLearningHistorySelectors();

        retryUntil(annotateAdminUserDetailLearningHistorySelectors, {
            maxAttempts: 80,
            interval: 250
        });

        if (typeof $ !== 'undefined') {
            $(document).on(
                'loaded.bs.select rendered.bs.select refreshed.bs.select shown.bs.select changed.bs.select',
                '#learningoverview #status_select',
                annotateAdminUserDetailLearningHistorySelectors
            );
        }

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            annotateAdminUserDetailLearningHistorySelectors();
        }).observe(learningHistoryPanel, {
            childList: true,
            subtree: true
        });
    }

    function annotateTestStatisticsControls() {
        var testIds = getTestIds('statistics');
        var path = window.location.pathname.replace(/\/+$/, '');
        var container = document.getElementById('users-table-container');
        var testTable;

        if (!testIds || path !== '/admin/statistics/test' || !container) {
            return false;
        }

        setDataTestId(document.getElementById('filterStatisticButton'), testIds.test_filter_button);

        annotateBootstrapSelect('#filtersContainer #status_select', {
            select: testIds.test_status_select,
            nativeSelect: true
        });

        testTable = container.querySelector('.statistics-table-wrapper #table');
        setDataTestId(testTable, testIds.test_table);

        if (testTable) {
            setDataTestId(
                testTable.querySelector('thead th:nth-child(2)'),
                testIds.test_column_last_name
            );
            setDataTestId(
                testTable.querySelector('thead th:nth-child(3)'),
                testIds.test_column_first_name
            );
            setDataTestId(
                testTable.querySelector('thead th:nth-child(5)'),
                testIds.test_column_learning_unit
            );
            setDataTestId(
                testTable.querySelector('thead th:nth-child(7)'),
                testIds.test_column_status
            );
        }

        return true;
    }

    function observeTestStatisticsControls() {
        var path = window.location.pathname.replace(/\/+$/, '');
        var container = document.getElementById('users-table-container');

        if (!getE2eConfig() || path !== '/admin/statistics/test' || !container) {
            return;
        }

        annotateTestStatisticsControls();

        retryUntil(annotateTestStatisticsControls, {
            maxAttempts: 40,
            interval: 250
        });

        if (typeof $ !== 'undefined') {
            $(document).on(
                'loaded.bs.select rendered.bs.select refreshed.bs.select shown.bs.select changed.bs.select',
                '#filtersContainer #status_select',
                annotateTestStatisticsControls
            );
        }

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            annotateTestStatisticsControls();
        }).observe(container, {
            childList: true,
            subtree: true
        });
    }

    function annotateCourseStatisticsControls() {
        var testIds = getTestIds('statistics');
        var path = window.location.pathname.replace(/\/+$/, '');
        var container = document.getElementById('users-table-container');
        var resetModal = document.getElementById('deleteModal');
        var courseTable;
        var csvActions;

        if (!testIds || path !== '/admin/statistics/courses' || !container) {
            return false;
        }

        setDataTestId(resetModal, testIds.course_reset_progress_modal);

        courseTable = container.querySelector('#table');
        setDataTestId(courseTable, testIds.course_table);
        setDataTestId(
            courseTable ? courseTable.querySelector('thead th:nth-child(4)') : null,
            testIds.course_column_learning_unit
        );

        if (resetModal) {
            setDataTestId(
                resetModal.querySelector('#deleteDeleteButton'),
                testIds.course_reset_progress_confirm_button
            );
        }

        setDataTestId(
            container.querySelector('.regular-export-buttons-collection'),
            testIds.course_export_button
        );
        setDataTestId(document.getElementById('includeSubgroups'), testIds.course_include_subgroups_checkbox);
        setDataTestId(
            document.getElementById('showHistoricalRecords'),
            testIds.course_include_historical_progress_checkbox
        );
        setDataTestId(document.getElementById('send-message'), testIds.course_send_message_button);

        annotateCourseStatisticsLearningUnitSelect();
        annotateBootstrapSelect('#filtersContainer #client_ids', {
            select: testIds.course_client_select,
            fallbackToSelect: false
        });
        annotateBootstrapSelect('#filtersContainer #group_id', {
            select: testIds.course_group_select,
            fallbackToSelect: false
        });
        setDataTestId(
            document.querySelector('#filtersContainer #client_ids'),
            testIds.course_client_native_select
        );
        setDataTestId(
            document.querySelector('#filtersContainer #group_id'),
            testIds.course_group_native_select
        );

        csvActions = container.querySelectorAll('.dt-button-collection .buttons-csv');

        for (var i = 0; i < csvActions.length; i++) {
            setDataTestId(csvActions[i], testIds.course_export_csv_action);
        }

        return true;
    }

    function annotateCourseStatisticsLearningUnitSelect() {
        var testIds = getTestIds('statistics');
        var path = window.location.pathname.replace(/\/+$/, '');
        var testId = testIds && testIds.course_learning_unit_select
            ? testIds.course_learning_unit_select
            : 'statistics-course-learning-unit-select';
        var nativeTestId = testIds && testIds.course_learning_unit_native_select
            ? testIds.course_learning_unit_native_select
            : 'statistics-course-learning-unit-native-select';
        var select = document.querySelector('#filtersContainer #unit_id[data-course]');
        var picker = getBootstrapSelect(select);
        var button = picker ? picker.querySelector('button.dropdown-toggle') : null;
        var existing = document.querySelectorAll('[data-testid="statistics-course-learning-unit-select"]');
        var i;

        if (path !== '/admin/statistics/courses' || !select) {
            return false;
        }

        for (i = 0; i < existing.length; i++) {
            if (existing[i] !== button) {
                existing[i].removeAttribute('data-testid');
            }
        }

        setDataTestId(select, nativeTestId);

        if (button) {
            setDataTestId(button, testId);

            return true;
        }

        return false;
    }

    function observeCourseStatisticsLearningUnitSelect() {
        var path = window.location.pathname.replace(/\/+$/, '');
        var filtersContainer = document.getElementById('filtersContainer');
        var observerRoot = filtersContainer || document.body || document.documentElement;

        if (path !== '/admin/statistics/courses') {
            return;
        }

        annotateCourseStatisticsLearningUnitSelect();

        retryUntil(annotateCourseStatisticsLearningUnitSelect, {
            maxAttempts: 40,
            interval: 250
        });

        if (typeof $ !== 'undefined') {
            $(document).on(
                'loaded.bs.select rendered.bs.select refreshed.bs.select shown.bs.select changed.bs.select',
                '#filtersContainer #unit_id',
                annotateCourseStatisticsLearningUnitSelect
            );
        }

        if (typeof MutationObserver === 'undefined' || !observerRoot) {
            return;
        }

        new MutationObserver(function () {
            annotateCourseStatisticsLearningUnitSelect();
        }).observe(observerRoot, {
            childList: true,
            subtree: true
        });
    }

    function observeCourseStatisticsControls() {
        var path = window.location.pathname.replace(/\/+$/, '');
        var container = document.getElementById('users-table-container');

        if (path !== '/admin/statistics/courses' || !container) {
            return;
        }

        annotateCourseStatisticsControls();

        retryUntil(annotateCourseStatisticsControls, {
            maxAttempts: 40,
            interval: 250
        });

        if (typeof $ !== 'undefined') {
            $(document).on(
                'loaded.bs.select rendered.bs.select refreshed.bs.select shown.bs.select changed.bs.select',
                '#filtersContainer #unit_id, #filtersContainer #client_ids, #filtersContainer #group_id',
                annotateCourseStatisticsControls
            );
        }

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            annotateCourseStatisticsControls();
        }).observe(container, {
            childList: true,
            subtree: true
        });
    }

    function isCourseStatisticsMessageComposePage() {
        var path = window.location.pathname.replace(/\/+$/, '');
        var referrerUrl;

        if (path !== '/message/create') {
            return false;
        }

        if (!document.referrer) {
            return false;
        }

        try {
            referrerUrl = new URL(document.referrer, window.location.origin);

            return referrerUrl.pathname.replace(/\/+$/, '') === '/admin/statistics/courses';
        } catch (error) {
            return false;
        }
    }

    function getMessageCreateBodyEditorHost() {
        var bodyField = document.getElementById('body');
        var bodyContainer = bodyField && bodyField.parentElement ? bodyField.parentElement : null;
        var editable = bodyContainer ? bodyContainer.querySelector('.ck-content') : null;

        return editable;
    }

    function annotateMessageCreateBodyEditor() {
        var testIds = getTestIds('statistics') || {};
        var path = window.location.pathname.replace(/\/+$/, '');
        var bodyEditor = getMessageCreateBodyEditorHost();

        if (path !== '/message/create') {
            return false;
        }

        setDataTestId(
            bodyEditor,
            testIds.message_create_body_editor || 'message-create-body-editor'
        );

        return !!bodyEditor;
    }

    function observeMessageCreateBodyEditor() {
        var path = window.location.pathname.replace(/\/+$/, '');
        var messageContainer = document.getElementById('message-container');
        var observerRoot = messageContainer || document.body || document.documentElement;

        if (path !== '/message/create') {
            return;
        }

        annotateMessageCreateBodyEditor();

        retryUntil(annotateMessageCreateBodyEditor, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined' || !observerRoot) {
            return;
        }

        new MutationObserver(function () {
            annotateMessageCreateBodyEditor();
        }).observe(observerRoot, {
            childList: true,
            subtree: true
        });
    }

    function annotateCourseStatisticsMessageCompose() {
        var testIds = getTestIds('statistics');
        var messageContainer = document.getElementById('message-container');
        var bodyField = document.getElementById('body');

        if (!testIds || !isCourseStatisticsMessageComposePage() || !messageContainer) {
            return false;
        }

        setDataTestId(messageContainer, testIds.course_message_modal);
        setDataTestId(messageContainer.querySelector('input[name="title"]'), testIds.course_message_subject_input);
        setDataTestId(bodyField, testIds.course_message_body_input);
        annotateMessageCreateBodyEditor();
        setDataTestId(document.getElementById('send_email'), testIds.course_message_email_checkbox);
        setDataTestId(
            messageContainer.querySelector('button[type="submit"].send-message'),
            testIds.course_message_submit_button
        );

        return !!bodyField;
    }

    function observeCourseStatisticsMessageCompose() {
        var messageContainer = document.getElementById('message-container');

        if (!isCourseStatisticsMessageComposePage() || !messageContainer) {
            return;
        }

        annotateCourseStatisticsMessageCompose();

        retryUntil(annotateCourseStatisticsMessageCompose, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            annotateCourseStatisticsMessageCompose();
        }).observe(messageContainer, {
            childList: true,
            subtree: true
        });
    }

    function annotateSystemConfigurationExternalBookingSaveButtons() {
        var testIds = getTestIds('super_admin_system_configuration');
        var checkbox = document.getElementById('foreignBookingCheckbox');
        var modalIds = ['addSystemMessagesModal', 'removeSystemMessagesModal'];

        if (!testIds || !checkbox) {
            return;
        }

        for (var i = 0; i < modalIds.length; i++) {
            var modal = document.getElementById(modalIds[i]);

            if (modal) {
                setDataTestId(
                    modal.querySelector('.modal-footer button.btn.positive'),
                    testIds.external_booking_save_button
                );
            }
        }
    }

    function annotateSystemConfigurationPrioritizationControls() {
        var testIds = getSystemConfigurationPrioritizationTestIds();
        var bookingDetailsSection = document.querySelector(
            '[data-testid="super-admin-system-configuration-booking-details-section"]'
        );
        var prioritizationTable = document.getElementById('prioritization_points_table');

        if (!testIds || (!bookingDetailsSection && !prioritizationTable)) {
            return false;
        }

        annotateBootstrapSelect('select[data-setting="points"]', {
            select: testIds.prioritization_points_values_select
        });

        setDataTestId(
            document.querySelector('#confirmPeriodModal .modal-footer button.btn.positive'),
            testIds.prioritization_create_period_confirm_button
        );
        setDataTestId(
            document.querySelector('#closeModal .modal-footer button.btn.positive'),
            testIds.prioritization_close_period_confirm_button
        );

        return true;
    }

    function observeSystemConfigurationPrioritizationControls() {
        var prioritizationRoot = document.querySelector(
            '[data-testid="super-admin-system-configuration-booking-details-section"], '
            + '#prioritization_points_table, '
            + '#confirmPeriodModal, '
            + '#closeModal'
        );

        if (!getE2eConfig()) {
            return;
        }

        if (!prioritizationRoot) {
            return;
        }

        annotateSystemConfigurationPrioritizationControls();

        retryUntil(annotateSystemConfigurationPrioritizationControls, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof $ !== 'undefined') {
            $('select[data-setting="points"]').on(
                'loaded.bs.select rendered.bs.select refreshed.bs.select shown.bs.select changed.bs.select',
                annotateSystemConfigurationPrioritizationControls
            );
        }

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        var systemConfiguration = document.getElementById('system_configuration')
            || prioritizationRoot.parentElement
            || prioritizationRoot;

        if (systemConfiguration) {
            new MutationObserver(function () {
                annotateSystemConfigurationPrioritizationControls();
            }).observe(systemConfiguration, {
                childList: true,
                subtree: true
            });
        }
    }

    function annotateLearnerSeminarInterestModal() {
        var testIds = getLearnerSeminarInterestTestIds();
        var modal = document.getElementById('UserInterestModal');

        if (!testIds || !modal) {
            return false;
        }

        setDataTestId(modal, testIds.modal);
        annotateBootstrapSelect('#UserInterestModal #user_interest', {
            select: testIds.points_select,
            nativeSelect: true
        });
        setDataTestId(modal.querySelector('#extra_points'), testIds.extra_points_checkbox);
        setDataTestId(modal.querySelector('#extra-points-field'), testIds.extra_points_field);
        setDataTestId(modal.querySelector('#user_extra_points'), testIds.extra_points_value);
        setDataTestId(modal.querySelector('.modal-footer #confirm-button'), testIds.confirm_button);
        setDataTestId(
            modal.querySelector('.modal-footer button.neutral[data-dismiss="modal"]'),
            testIds.cancel_button
        );

        return true;
    }

    function observeLearnerSeminarInterestModal() {
        var observedModal = null;
        var modalObserver = null;
        var root = document.body || document.documentElement;

        if (!getE2eConfig()) {
            return;
        }

        function bindModalObserver() {
            var modal = document.getElementById('UserInterestModal');

            if (!modal) {
                return false;
            }

            if (modal === observedModal) {
                annotateLearnerSeminarInterestModal();
                return true;
            }

            observedModal = modal;
            annotateLearnerSeminarInterestModal();

            if (typeof $ !== 'undefined') {
                $(modal).on('shown.bs.modal', annotateLearnerSeminarInterestModal);
                $('#UserInterestModal #user_interest').on(
                    'loaded.bs.select rendered.bs.select refreshed.bs.select shown.bs.select changed.bs.select',
                    annotateLearnerSeminarInterestModal
                );
            }

            if (typeof MutationObserver !== 'undefined') {
                if (modalObserver) {
                    modalObserver.disconnect();
                }

                modalObserver = new MutationObserver(function () {
                    annotateLearnerSeminarInterestModal();
                });
                modalObserver.observe(modal, {
                    attributes: true,
                    attributeFilter: ['open', 'class', 'style', 'aria-hidden'],
                    childList: true,
                    subtree: true
                });
            }

            return true;
        }

        bindModalObserver();

        retryUntil(bindModalObserver, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined' || !root) {
            return;
        }

        new MutationObserver(function () {
            bindModalObserver();
        }).observe(root, {
            childList: true,
            subtree: true
        });
    }

    function annotateLearnerSeminarBookingActions() {
        var testIds = getTestIds('learner_seminar');
        var seminarRoots = document.querySelectorAll(
            '[data-unit-type="seminar"], [data-unit-type="SEMINAR"]'
        );
        var annotated = false;

        if (!testIds) {
            return false;
        }

        testIds.booking_action = testIds.booking_action || 'learner-seminar-booking-action';
        for (var i = 0; i < seminarRoots.length; i++) {
            var actions = seminarRoots[i].querySelectorAll(
                '.learning-unit-buttons .book-button.booking[onclick*="openBookingModal"], '
                + '.learning-unit-buttons .book-button.booking[onclick*="handleCartItems"]'
            );

            for (var j = 0; j < actions.length; j++) {
                var onclick = actions[j].getAttribute('onclick') || '';

                if (/['"]seminar['"]/i.test(onclick) && !/['"]meeting['"]/i.test(onclick)) {
                    setDataTestId(actions[j], testIds.booking_action);
                    annotated = true;
                }
            }
        }

        return annotated;
    }

    function observeLearnerSeminarBookingActions() {
        var root = document.body || document.documentElement;

        if (!getE2eConfig() || !root) {
            return;
        }

        annotateLearnerSeminarBookingActions();

        retryUntil(annotateLearnerSeminarBookingActions, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            annotateLearnerSeminarBookingActions();
        }).observe(root, {
            childList: true,
            subtree: true
        });
    }

    function isCurrentSeminarBookingContext() {
        return typeof bookingUnitType !== 'undefined' && isSeminarUnitType(bookingUnitType);
    }

    function annotateLearnerSeminarSelfBooking() {
        var testIds = getLearnerSeminarSelfBookingTestIds();
        var modal = document.getElementById('bookingModal');
        var modalContent = modal ? modal.querySelector('.modal-content') : null;
        var hasExternalBookingControls = !!document.getElementById('booking_others');
        var cancelButton;

        if (!testIds || !modal || !isCurrentSeminarBookingContext()) {
            return false;
        }

        setDataTestId(hasExternalBookingControls ? modalContent : modal, testIds.modal);
        setDataTestId(document.getElementById('booking_self'), testIds.for_self_option);
        setDataTestId(document.getElementById('billingAddress'), testIds.address_select);
        setDataTestId(document.getElementById('addAddressButton'), testIds.add_address_action);
        setDataTestId(document.getElementById('booking_condition_one'), testIds.confirmation_checkbox);
        setDataTestId(document.getElementById('booking_condition_two'), testIds.terms_checkbox);
        setDataTestId(document.getElementById('text_for_learner'), testIds.comment_input);
        setDataTestId(document.querySelector('#book-tab-buttons .next'), testIds.next_action);
        setDataTestId(modal.querySelector('#bookButton'), testIds.submit_action);

        cancelButton = modal.querySelector('#book-tab-buttons #cancelButton')
            || modal.querySelector('.modal-footer button.booking.neutral.modal-button');

        setDataTestId(cancelButton, testIds.cancel_action);

        return true;
    }

    function observeLearnerSeminarSelfBooking() {
        var observedModal = null;
        var modalObserver = null;
        var root = document.body || document.documentElement;

        if (!getE2eConfig() || !root) {
            return;
        }

        function bindModalObserver() {
            var modal = document.getElementById('bookingModal');

            if (!modal) {
                return false;
            }

            if (modal === observedModal) {
                annotateLearnerSeminarSelfBooking();
                return true;
            }

            observedModal = modal;
            annotateLearnerSeminarSelfBooking();

            if (typeof $ !== 'undefined') {
                $(modal).on('shown.bs.modal', annotateLearnerSeminarSelfBooking);
            }

            if (typeof MutationObserver !== 'undefined') {
                if (modalObserver) {
                    modalObserver.disconnect();
                }

                modalObserver = new MutationObserver(function () {
                    annotateLearnerSeminarSelfBooking();
                });
                modalObserver.observe(modal, {
                    attributes: true,
                    attributeFilter: ['open', 'class', 'style', 'aria-hidden'],
                    childList: true,
                    subtree: true
                });
            }

            return true;
        }

        bindModalObserver();

        retryUntil(bindModalObserver, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            bindModalObserver();
        }).observe(root, {
            childList: true,
            subtree: true
        });
    }

    function annotateLearnerSeminarExternalBooking() {
        var testIds = getTestIds('learner_seminar_external_booking');
        var modal = document.getElementById('bookingModal');
        var othersCheckbox = document.getElementById('booking_others');
        var unitTypes = window.global_vars ? window.global_vars.unit_types : null;
        var isSeminarBooking = typeof bookingUnitType !== 'undefined'
            && unitTypes
            && bookingUnitType === unitTypes.seminar;

        if (!testIds || !modal || !othersCheckbox || !isSeminarBooking) {
            return false;
        }

        setDataTestId(modal, testIds.modal);
        annotateBootstrapSelect('#supervisor_users', {
            select: testIds.user_select,
            option: testIds.user_option,
            optionSelector: '.dropdown-menu .inner '
                + 'li:not(.divider):not(.dropdown-header):not(.no-results) '
                + '> a.dropdown-item'
        });
        setDataTestId(modal.querySelector('#bookButton'), testIds.confirm_button);

        return true;
    }

    function observeLearnerSeminarExternalBooking() {
        var modal = document.getElementById('bookingModal');
        var othersCheckbox = document.getElementById('booking_others');

        if (!getE2eConfig() || !modal || !othersCheckbox) {
            return;
        }

        annotateLearnerSeminarExternalBooking();

        if (typeof $ !== 'undefined') {
            $(modal).on('shown.bs.modal', annotateLearnerSeminarExternalBooking);
            $('#supervisor_users').on(
                'loaded.bs.select rendered.bs.select refreshed.bs.select shown.bs.select changed.bs.select',
                annotateLearnerSeminarExternalBooking
            );
        }

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            annotateLearnerSeminarExternalBooking();
        }).observe(modal, {
            attributes: true,
            attributeFilter: ['open', 'class', 'style', 'aria-hidden'],
            childList: true,
            subtree: true
        });
    }

    function annotateInstructorDashboardSeminarTiles() {
        var testIds = getTestIds('instructor_dashboard');
        var path = window.location.pathname.replace(/\/+$/, '');
        var seminarRoot = document.getElementById('seminars');
        var tiles;

        if (!testIds || path !== '/instructor/dashboard' || !seminarRoot) {
            return;
        }

        tiles = seminarRoot.querySelectorAll('.learning-unit-container');

        for (var i = 0; i < tiles.length; i++) {
            setDataTestId(tiles[i], testIds.seminar_tile);
            setDataTestId(
                tiles[i].querySelector('[role="link"][onclick^="openUnit("]'),
                testIds.seminar_open_action
            );
        }
    }

    function annotateLearnerSeminarRequestControls() {
        var testIds = getTestIds('learner_seminar_request');
        var seminarRoots = document.querySelectorAll('[data-unit-type="seminar"]');

        if (!testIds) {
            return;
        }

        for (var i = 0; i < seminarRoots.length; i++) {
            var requestButton = seminarRoots[i].querySelector('button.requestButton[onclick^="requestReference("]');
            var cancelButton = seminarRoots[i].querySelector('button#cancelButton[onclick^="cancelRequest("]');
            var requestedButton = cancelButton
                ? seminarRoots[i].querySelector('button.requestButton:not(#cancelButton):not(.tiles-forward)')
                : null;

            setDataTestId(requestButton, testIds.request_button);
            setDataTestId(requestedButton, testIds.access_requested);
        }
    }

    function observeLearnerSeminarRequestControls() {
        var root = document.body || document.documentElement;

        if (!getE2eConfig() || !root) {
            return;
        }

        annotateLearnerSeminarRequestControls();

        retryUntil(annotateLearnerSeminarRequestControls, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            annotateLearnerSeminarRequestControls();
        }).observe(root, {
            childList: true,
            subtree: true
        });
    }

    function annotateLearnerSeminarAppointmentActions() {
        var testIds = getTestIds('learner_seminar_appointment');
        var seminarTestIds = getTestIds('learner_seminar');
        var appointments = document.querySelectorAll('[data-testid="learner-seminar-appointment"]');

        if (!testIds && !seminarTestIds) {
            return;
        }

        if (seminarTestIds) {
            seminarTestIds.booking_required_action = seminarTestIds.booking_required_action
                || 'learner-seminar-booking-required-action';
            seminarTestIds.post_removal_booking_required_state = seminarTestIds.post_removal_booking_required_state
                || 'learner-seminar-post-removal-booking-required-state';
            seminarTestIds.post_deregistration_readd_allowed_state = seminarTestIds.post_deregistration_readd_allowed_state
                || 'learner-seminar-post-deregistration-readd-allowed-state';
        }

        if (testIds) {
            testIds.booking_required_state = testIds.booking_required_state
                || 'learner-seminar-appointment-booking-required-state';
            testIds.registration_unavailable_state = testIds.registration_unavailable_state
                || 'learner-seminar-appointment-registration-unavailable-state';
        }

        for (var i = 0; i < appointments.length; i++) {
            var actions = appointments[i].querySelectorAll('button[onclick]');
            var stateRoot = appointments[i].querySelector('.meeting-details-third-row');
            var bookingActions = appointments[i].querySelectorAll('.booking');
            var hasBookingAction = bookingActions.length > 0;
            var hasRegisterAction = false;

            if (seminarTestIds) {
                for (var k = 0; k < bookingActions.length; k++) {
                    setDataTestId(bookingActions[k], seminarTestIds.booking_required_action);
                }

                if (hasBookingAction && stateRoot) {
                    setDataTestId(stateRoot, seminarTestIds.post_removal_booking_required_state);
                }
            }

            if (testIds && hasBookingAction) {
                var bookingRequiredState = bookingActions[0]
                    ? bookingActions[0].closest('.grid-justify-end-columns') || bookingActions[0].parentElement
                    : null;

                setDataTestId(bookingRequiredState, testIds.booking_required_state);
            }

            for (var j = 0; j < actions.length; j++) {
                var onclick = actions[j].getAttribute('onclick') || '';

                if (/^\s*(?:requestMeeting|requestMeetingPlanning|userInterestAction)\s*\(/.test(onclick)) {
                    setDataTestId(actions[j], testIds ? testIds.request_access_button : null);
                } else if (/^\s*deregisterConfirm\s*\(/.test(onclick)) {
                    setDataTestId(actions[j], testIds ? testIds.deregister_button : null);
                } else if (/^\s*startTest\s*\(/.test(onclick)) {
                    setDataTestId(actions[j], testIds ? testIds.test_start_action : null);
                } else if (/^\s*enroll\s*\(/.test(onclick)) {
                    hasRegisterAction = true;
                }
            }

            if (seminarTestIds && hasRegisterAction && !hasBookingAction && stateRoot) {
                setDataTestId(stateRoot, seminarTestIds.post_deregistration_readd_allowed_state);
            }

            if (testIds && !hasRegisterAction && !hasBookingAction && stateRoot) {
                var unavailableState = stateRoot.querySelector(
                    'button[disabled], button[aria-disabled="true"], .alert.alert-info, .meeting-info-button'
                );

                setDataTestId(unavailableState, testIds.registration_unavailable_state);
            }
        }
    }

    function annotateLearnerSeminarCertificateActions() {
        var testIds = getTestIds('learner_seminar');
        var seminarRoots = document.querySelectorAll(
            '[data-unit-type="seminar"], tr[data-type="SEMINAR"], tr[data-type="seminar"]'
        );

        if (!testIds) {
            return false;
        }

        var annotated = false;

        for (var i = 0; i < seminarRoots.length; i++) {
            var actions = seminarRoots[i].querySelectorAll(
                '.certificate-element a[href*="/certificate/"], a.certificate[href*="certificate"]'
            );

            for (var j = 0; j < actions.length; j++) {
                setDataTestId(actions[j], testIds.certificate_download_action);
                annotated = true;
            }
        }

        return annotated;
    }

    function observeLearnerSeminarCertificateActions() {
        var observedRoots = [];
        var pageRoot = document.body || document.documentElement;

        if (!getE2eConfig()) {
            return;
        }

        function observeRoots() {
            var seminarRoots = document.querySelectorAll(
                '[data-unit-type="seminar"], tr[data-type="SEMINAR"], tr[data-type="seminar"]'
            );

            annotateLearnerSeminarCertificateActions();

            if (typeof MutationObserver === 'undefined') {
                return seminarRoots.length > 0;
            }

            for (var i = 0; i < seminarRoots.length; i++) {
                if (observedRoots.indexOf(seminarRoots[i]) !== -1) {
                    continue;
                }

                observedRoots.push(seminarRoots[i]);

                new MutationObserver(function () {
                    annotateLearnerSeminarCertificateActions();
                }).observe(seminarRoots[i], {
                    childList: true,
                    subtree: true
                });
            }

            return seminarRoots.length > 0;
        }

        observeRoots();

        retryUntil(observeRoots, {
            maxAttempts: 20,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined' || !pageRoot) {
            return;
        }

        new MutationObserver(function () {
            observeRoots();
        }).observe(pageRoot, {
            childList: true,
            subtree: true
        });
    }

    function getInstructorRequestSubjectCandidates() {
        return getMessageSubjectCandidates(
            ['meeting_instructor_participation_request'],
            [
                'Anfrage, Dozent:in zu sein',
                'Anfrage, Meeting-Instruktor zu sein',
                'Request to be meeting instructor'
            ]
        );
    }

    function getInstructorDecisionSubjectCandidates() {
        return getMessageSubjectCandidates(
            [
                'meeting_instructor_participation_confirmation',
                'meeting_instructor_participation_denied'
            ],
            [
                'Der Benutzer hat zugestimmt, Dozent im Meeting zu sein',
                'hat es abgelehnt, als Kursleitung an dem Seminar',
                'Der Dozent',
                'User has agreed to be an instructor in the meeting',
                'has rejected being an instructor in the seminar',
                'The lecturer'
            ]
        );
    }

    function annotateLearnerMessages() {
        var testIds = getTestIds('learner_messages');
        var requestSubjects = getInstructorRequestSubjectCandidates();
        var decisionSubjects = getInstructorDecisionSubjectCandidates();
        var messageContainer = document.getElementById('message-container');
        var messageBody = messageContainer ? messageContainer.querySelector('.transparent_background') : null;
        var rows;

        if (!testIds || !messageContainer) {
            return false;
        }

        testIds.inbox_table = testIds.inbox_table || 'learner-messages-inbox-table';
        testIds.instructor_request_row = testIds.instructor_request_row
            || 'learner-messages-instructor-request-row';
        testIds.instructor_request_action = testIds.instructor_request_action
            || 'learner-messages-instructor-request-action';
        testIds.instructor_request_detail = testIds.instructor_request_detail
            || 'learner-messages-instructor-request-detail';
        testIds.instructor_request_accept_action = testIds.instructor_request_accept_action
            || 'learner-messages-instructor-request-accept-action';
        testIds.instructor_request_reject_action = testIds.instructor_request_reject_action
            || 'learner-messages-instructor-request-reject-action';
        testIds.instructor_decision_notification_row = testIds.instructor_decision_notification_row
            || 'learner-messages-instructor-decision-notification-row';
        testIds.instructor_decision_notification_detail = testIds.instructor_decision_notification_detail
            || 'learner-messages-instructor-decision-notification-detail';

        setDataTestId(document.getElementById('inbox'), testIds.inbox_table);

        rows = messageContainer.querySelectorAll('#inbox tbody tr, #requested tbody tr');

        for (var i = 0; i < rows.length; i++) {
            var action = rows[i].querySelector('a[href*="/message/"]');
            var subject = getText(action);

            if (textMatchesAny(subject, requestSubjects)) {
                setDataTestId(rows[i], testIds.instructor_request_row);
                setDataTestId(action, testIds.instructor_request_action);
            } else if (textMatchesAny(subject, decisionSubjects)) {
                setDataTestId(rows[i], testIds.instructor_decision_notification_row);
            }
        }

        if (messageBody) {
            var detailText = getText(messageBody);

            if (textMatchesAny(detailText, requestSubjects)) {
                setDataTestId(messageBody, testIds.instructor_request_detail);
                setDataTestId(
                    messageBody.querySelector('a[onclick^="approveMeetingInstructorRequest"]'),
                    testIds.instructor_request_accept_action
                );
                setDataTestId(
                    messageBody.querySelector('a[onclick^="declineeMeetingInstructorRequest"]'),
                    testIds.instructor_request_reject_action
                );
            } else if (textMatchesAny(detailText, decisionSubjects)) {
                setDataTestId(messageBody, testIds.instructor_decision_notification_detail);
            }
        }

        return !!rows.length || !!messageBody;
    }

    function observeLearnerMessages() {
        var messageContainer = document.getElementById('message-container');

        if (!getE2eConfig() || !messageContainer) {
            return;
        }

        annotateLearnerMessages();

        retryUntil(annotateLearnerMessages, {
            maxAttempts: 30,
            interval: 250
        });

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        new MutationObserver(function () {
            annotateLearnerMessages();
        }).observe(messageContainer, {
            childList: true,
            subtree: true
        });
    }

    function annotateModal(modal, testIds, confirmPattern) {
        var buttons;

        if (!modal || !testIds) {
            return;
        }

        setDataTestId(modal, testIds.modal);
        setDataTestId(
            modal.querySelector('.modal-footer button[data-dismiss="modal"].neutral'),
            testIds.cancel_button
        );

        buttons = modal.querySelectorAll('.modal-footer button[onclick]');

        for (var i = 0; i < buttons.length; i++) {
            if (confirmPattern.test(buttons[i].getAttribute('onclick') || '')) {
                setDataTestId(buttons[i], testIds.confirm_button);
                break;
            }
        }
    }

    function annotateContextualConfirmationModals() {
        var path = window.location.pathname.replace(/\/+$/, '');
        var publishTestIds = getTestIds('backend_learning_unit_publish');
        var curriculumTestIds = getTestIds('backend_curriculum_publish');
        var seminarTestIds = getTestIds('backend_seminar_meetings');
        var userTestIds = getTestIds('admin_user_detail');

        if (publishTestIds) {
            annotateModal(document.getElementById('publishContentModal'), {
                modal: publishTestIds.publish_modal,
                confirm_button: publishTestIds.publish_confirm_button,
                cancel_button: publishTestIds.publish_cancel_button
            }, /^\s*publishContent\s*\(/);
            annotateModal(document.getElementById('unpublishContentModal'), {
                modal: publishTestIds.unpublish_modal,
                confirm_button: publishTestIds.unpublish_confirm_button,
                cancel_button: publishTestIds.unpublish_cancel_button
            }, /^\s*unpublishContent\s*\(/);
        }

        if (curriculumTestIds && /^\/admin\/series\/\d+$/.test(path)) {
            annotateModal(document.getElementById('publishModal'), curriculumTestIds, /^\s*publishVersion\s*\(/);
        }

        if (seminarTestIds && document.getElementById('meetings')) {
            annotateModal(document.getElementById('combineMeetingsModal'), {
                modal: seminarTestIds.combine_modal,
                confirm_button: seminarTestIds.combine_confirm_button,
                cancel_button: seminarTestIds.combine_cancel_button
            }, /^\s*combineMeetings\s*\(/);
            annotateModal(document.getElementById('deleteMeetingModal'), {
                modal: seminarTestIds.delete_modal,
                confirm_button: seminarTestIds.delete_confirm_button,
                cancel_button: seminarTestIds.delete_cancel_button
            }, /^\s*deleteMeetingHandle\s*\(/);
        }

        if (userTestIds && /^\/admin\/users\/\d+/.test(path)) {
            setDataTestId(
                document.getElementById('deleteItemModal'),
                userTestIds.learning_history_delete_modal
            );
        }
    }

    function annotateLearnerCourseVersionChoice() {
        var testIds = getTestIds('learner_course_version');
        var path = window.location.pathname.replace(/\/+$/, '');
        var modal = document.getElementById('askNewVersionModal');

        if (!testIds || !modal || !/^\/(?:details\/\d+\/course|course\/\d+\/info)(?:\/|$)/.test(path)) {
            return;
        }

        setDataTestId(modal, testIds.modal);
        setDataTestId(modal.querySelector('#askNewVersionModalLabel'), testIds.title);
        setDataTestId(modal.querySelector('.modal-body'), testIds.message);

        var buttons = modal.querySelectorAll('.modal-footer button[onclick]');

        for (var i = 0; i < buttons.length; i++) {
            var onclick = buttons[i].getAttribute('onclick') || '';

            if (/^\s*startNewVersion\s*\(\s*1\s*\)\s*;?\s*$/.test(onclick)) {
                setDataTestId(buttons[i], testIds.yes_button);
            } else if (/^\s*startNewVersion\s*\(\s*0\s*\)\s*;?\s*$/.test(onclick)) {
                setDataTestId(buttons[i], testIds.no_button);
            } else if (/^\s*\$\(\s*(['"])#askNewVersionModal\1\s*\)\.hide\(\s*\)\s*;?\s*$/.test(onclick)) {
                setDataTestId(buttons[i], testIds.cancel_button);
            }
        }
    }

    function annotateBackendCourseVersionControls() {
        var testIds = getTestIds('courses');
        var path = window.location.pathname.replace(/\/+$/, '');

        if (!testIds || !/^\/admin\/course\/\d+$/.test(path)) {
            return;
        }

        setDataTestId(
            document.querySelector('[data-testid="backend-learning-unit-create-version-button"]'),
            testIds.create_version_button
        );
        setDataTestId(
            document.querySelector('[data-testid="backend-learning-unit-publish-version-button"]'),
            testIds.publish_version_button
        );
    }

    // Only annotate identities already exposed by application DOM/plugin state.
    function observeMenuCategories() {
        var ids = getTestIds('menu_categories');
        if (!getE2eConfig() || !ids) {
            return;
        }

        function addId(element, id) {
            if (element && !element.hasAttribute('data-testid')) {
                setDataTestId(element, id);
            }
        }

        function observe(container, annotate) {
            annotate();
            if (container && typeof MutationObserver !== 'undefined') {
                var observer = new MutationObserver(annotate);
                observer.observe(container, { childList: true, subtree: true });
                window.addEventListener('pagehide', function () { observer.disconnect(); }, { once: true });
            }
        }

        var path = window.location.pathname.replace(/\/+$/, '');
        if (/^\/admin\/custom\/category\/(create|\d+\/edit)$/.test(path)) {
            addId(document.querySelector('form input[name="name"]'), ids.name_input);
        }

        var menu = document.querySelector('#frontend-menu-overlay #menu-items');
        if (menu) {
            observe(menu, function () {
                menu.querySelectorAll('li[onclick] > a.clickable').forEach(function (link) {
                    var match = link.parentElement.getAttribute('onclick').match(/^\s*setItem\(\s*([1-9]\d*)\s*\)/);
                    if (match) {
                        addId(link, ids.menu_prefix + match[1]);
                    }
                });
            });
        }

        document.querySelectorAll('[data-testid="learner-dashboard-menu-category-open-category-action"]').forEach(function (link) {
            var match = (link.getAttribute('onclick') || '').match(/^\s*setItem\(\s*([1-9]\d*)\s*\)/);
            if (match) {
                addId(link.closest('#latest-notes'), ids.widget_prefix + match[1]);
            }
        });

        var select = document.querySelector('select[name="menu_category"]#category_id');
        if (select && /^\/admin\//.test(path)) {
            function annotatePicker() {
                var picker = getBootstrapSelect(select);
                addId(picker && picker.querySelector('button.dropdown-toggle'), ids.select);
                var plugin = window.jQuery ? window.jQuery(select).data('selectpicker') : null;
                var elements = plugin && plugin.selectpicker && plugin.selectpicker.main
                    ? plugin.selectpicker.main.elements : null;
                Array.prototype.forEach.call(select.options, function (option) {
                    if (!/^\d+$/.test(option.value)) {
                        return;
                    }
                    var item = elements && elements[option.liIndex];
                    var action = item && item.querySelector('a');
                    var id = ids.option_prefix + option.value;
                    // Bootstrap-select may reuse its own option nodes on refresh.
                    if (action && (action.getAttribute('data-testid') || '').indexOf(ids.option_prefix) === 0) {
                        setDataTestId(action, id);
                    } else {
                        addId(action, id);
                    }
                });
                return !!picker;
            }
            observe(select.closest('td'), annotatePicker);
            retryUntil(annotatePicker, { maxAttempts: 30, interval: 250 });
            if (window.jQuery) {
                window.jQuery(select).on('loaded.bs.select rendered.bs.select refreshed.bs.select shown.bs.select', annotatePicker);
            }
        }

        var collection = document.querySelector('[data-testid="learner-courses-collection"]');
        if (collection && path === '/courses') {
            var root = document.getElementById('main-container');
            // This storage value is the category_id actually sent by filterUnits.
            try {
                var categoryId = window.localStorage.getItem('category_id');
                if (/^[1-9]\d*$/.test(categoryId || '')) {
                    addId(root, ids.destination_prefix + categoryId);
                }
            } catch (error) {
                // Storage can be unavailable; never infer category identity from its title.
            }
            addId(document.getElementById('units-table-loader'), ids.loader);
            addId(document.getElementById('sorting_filter'), ids.sorting_native_select);
            observe(document.getElementById('filter-container'), function () {
                addId(document.querySelector('button[data-id="units_filter"]'), ids.filter_control);
                addId(document.querySelector('button[data-id="sorting_filter"]'), ids.sorting_control);
            });
        }
    }

    function initE2eSelectors() {
        observeMenuCategories();
        observeGroupTreeItems();
        observeTopicTreeItems();
        observePageMenuTreeItems();
        annotateFrontendMenuItems();
        setCkEditorDescriptionTestId();
        setUploadInputTestId();
        observeApprovalSteps();
        observeQuestionAnswers();
        observeUserRestoreActions();
        observeCurriculumUnitStartActions();
        observePdfOverlayReadiness();
        observeLearnerDashboardCalendar();
        observeInstructorDashboardCalendar();
        annotateInstructorDashboardSeminarTiles();
        observeLearnerSeminarRequestControls();
        observeLearnerSeminarBookingActions();
        observeLearnerSeminarMeetingDetailModal();
        observeLearnerSeminarAppointmentRegisterButtons();
        annotateLearnerSeminarAppointmentActions();
        observeSeminarMeetingDocuments();
        annotateAdminConfigurationDashboard();
        observeSystemConfigurationDeregistrationReasons();
        observeBackendTestPassPercentageInput();
        observeLearningUnitTopicPicker();
        observeBackendSeminarFormSelects();
        observeAdminSeminarMeetingForm();
        observeAdminSeminarGroupAssignment();
        observeAdminUserDetail();
        observeBackendToasts();
        observeAdminGroupUsers();
        observeAdminUsersIndex();
        observeAdminMeetingParticipants();
        observeCourseStatisticsProgress();
        observeBackendCoursesIndex();
        observeBackendSeminarDuplicationControls();
        annotateBackendCourseScormDetail();
        observeBackendMediaPreview();
        annotateBackendCourseDeleteConfirmation();
        annotateBackendCourseVersionControls();
        annotateBackendCourseCreateVersionConfirmation();
        annotateLearnerCourseVersionChoice();
        annotateBackendCoursePublishModal();
        annotateContextualConfirmationModals();
        annotateAdminUserDetailPromoteSuperAdminModal();
        annotateLearnerSeminarDeregisterModal();
        observeLearnerSeminarCertificateActions();
        observeLearnerMessages();
        observeSupervisorMandatoryUnits();
        observeAdminUserDetailLearningUnitSelectors();
        observeAdminUserDetailLearningHistorySelectors();
        observeCourseStatisticsLearningUnitSelect();
        observeCourseStatisticsControls();
        observeMessageCreateBodyEditor();
        observeCourseStatisticsMessageCompose();
        observeTestStatisticsControls();
        annotateSystemConfigurationExternalBookingSaveButtons();
        observeSystemConfigurationPrioritizationControls();
        observeLearnerSeminarInterestModal();
        observeLearnerSeminarSelfBooking();
        observeLearnerSeminarExternalBooking();
        observeQrMeetingParticipation();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initE2eSelectors);
    } else {
        initE2eSelectors();
    }
})();
